export default {
  "t-menu": "菜单",
  "t-device-trend-chart": "设备趋势图",
  "t-dashboard": "仪表板",
  "t-search": "搜索",
  "t-reset": "重置",
  "t-default": "默认",
  "t-system": "系统",
  "t-system-param": "系统参数",
  "t-normal": "正常",
  "t-not-supported": "不支持",
  "t-suspend": "暂停",
  "t-create": "添加",
  "t-edit": "编辑",
  "t-copy": "复制",
  "t-export": "导出",
  "t-download": "下载",
  "t-install": "安装",
  "t-clean": "清除",
  "t-enter": "输入",
  "t-select": "选择",
  "t-selected": "已选择",
  "t-next": "下一步",
  "t-submit": "提交",
  "t-update": "更新",
  "t-cancel": "取消",
  "t-cancel-reset": "重置 & 取消",
  "t-name": "名称",
  "t-alias": "别名",
  "t-value": "值",
  "t-from": "来自",
  "t-user-name": "用户名",
  "t-current": "当前",
  "t-new": "新",
  "t-password": "密码",
  "t-confirm-password": "确认密码",
  "t-length": "长度",
  "t-type": "类型",
  "t-check": "检查",
  "t-radius": "半径",
  "t-refresh": "刷新",
  "t-delete": "删除",
  "t-deleting": "删除中",
  "t-import": "导入",
  "t-confirm": "确认",
  "t-confirm-to": "您确定",
  "t-confirm-delete": "确定要删除 - {param}",
  "t-confirm-unbind": "确定要解绑 - {param}",
  "t-confirm-clean-logs": "确定要删除日志吗？",
  "t-detail": "详情",
  "t-usage": "使用",
  "t-records": "详情",
  "t-location": "位置",
  "t-add": "添加",
  "t-size": "大小",
  "t-website": "网址",
  "t-address": "地址",
  "t-remark": "备注",
  "t-description": "描述",
  "t-description-max-length": "描述不能超过500个字符",
  "t-phone": "电话",
  "t-phone-number": "电话",
  "t-file": "文件",
  "t-batch-file": "批量推送文件",
  "t-push-decompressed-file": "下载后自动解压压缩包",
  "t-push-decompressed-file-tip": "启用后，下载的压缩包将在目标设备上自动解压",
  "t-icon": "图标",
  "t-status": "状态",
  "t-action": "操作",
  "t-code": "代码",
  "t-id": "ID",
  "t-revoke": "撤销",
  "t-create-by": "创建人",
  "t-create-time": "创建时间",
  "t-first-connect-time": "首次连接时间",
  "t-executed-at": "执行时间",
  "t-execution-time": "执行时间",
  "t-execute-by": "执行人",
  "t-expiration-time": "过期时间",
  "t-modified-by": "修改人",
  "t-modified-time": "修改日期",
  "t-last-update-by": "最后更新人",
  "t-last-update-time": "最后更新日期",
  "t-date": "日期",
  "t-seconds": "秒",
  "t-minute": "分",
  "t-hour": "小时",
  "t-clock": "clock",
  "t-day": "天",
  "t-day-number": "号",
  "t-month": "月",
  "t-week": "周",
  "t-year": "年",
  "t-region": "地区",
  "t-continent": "大陆",
  "t-basic": "经典版",
  "t-premium": "高级版",
  "t-switch": "切换",
  "t-quantity": "数量",
  "t-success": "成功",
  "t-fail": "失败",
  "t-pending": "进行中",
  "t-reverted": "撤销",
  "t-revoke-success-tip": "撤销已提交，请稍后查看任务列表。",
  "t-yes": "是",
  "t-no": "否",
  "t-login": "登录",
  "t-logout": "退出",
  "t-last-online-time": "上次在线时间",
  "t-last-updated-time": "上次数据更新时间",
  "t-back": "返回",
  "t-duration": "持续时间",
  "t-click-check": "点击查看",
  "t-aborted": "撤销",
  "t-terminal-supported-functions": "终端类型",
  "t-format": "格式",
  "t-disable-signature": "禁用签名",
  "t-polygon": "多边形",
  "t-radius-in-meters": "半径 [50-9999]米",
  "t-radius-in-hours": "持续时间 [0-72]小时",
  "t-duration-value-range": "持续时间范围为0-72小时",
  "t-radius-value-range":"半径范围为50-9999米",
  "t-loading": "加载中...",
  "t-image": "图片",
  "t-video": "音频",
  "t-text": "文本",
  "t-html": "HTML",
  "t-required": "是必填项",
  "t-remove": "移除",
  "t-logo": "标志",
  "t-partner-portal-logo": "合作伙伴门户标志",
  "t-notfound-result": "很抱歉！未找到结果",
  "t-set": "设置",
  "t-number": "数量",
  "t-login-as-partner": "以合作伙伴身份登录",
  "t-logout-as-partner": "以合作伙伴身份注销",
  "t-abnormal-devices": "异常设备",
  "t-abnormal-device-status": "异常设备状态",
  "t-last-7-days": "最近7天",
  "t-last-14-days": "最近14天",
  "t-last-30-days": "最近30天",
  "t-last-90-days": "最近90天",
  "t-last-365-days": "最近365天",
  "t-last-days-number": "最近{param}天",
  "t-table": "表格",
  "t-head": "标题",
  "t-open": "开启",
  "t-close": "关闭",
  "t-notification": "通知",
  "t-public": "公开的",
  "t-welcome-back": "欢迎回来",
  "t-sign-in-continue-storm": "继续STORM以登录",
  "t-remember-me": "记住我",
  "t-sign-in": "登录",
  "t-please-wait": "登录中",
  "t-storm-introduction-title1": "智能终端远程操控管理系统",
  "t-storm-introduction-title2": "飞天研发了下一代TMS管理平台即“STORM”平台",
  "t-storm-introduction-title3": "含消息推送服务、远程密钥注入、OTA远程升级、终端设备远程管理等功能",
  "t-login-status-expired": "登录已超时，请重新登录！",


  "t-tooltip-device": "SN,TID,MID,IMEI",
  "t-sn": "SN",
  "t-terminal-management-system": "Terminal Management System",
  "t-device-mgmt": "设备管理",
  "t-uninstall": "卸载",
  "t-uninstall-block": "禁止卸载",
  "t-device": "设备",
  "t-device-type": "设备类型",
  "t-ecr-pos": "组合终端",
  "t-pos": "终端",
  "t-ecr": "组合",
  "t-serial-number": "序列号",
  "t-product-bundle": "组合产品型号",
  "t-device-detail": "设备详情",
  "t-charts-devices": "设备",
  "t-charts-push-report": "推送记录",
  "t-bind": "绑定",
  "t-bind-to": "绑定到",
  "t-unbind": "解绑",
  "t-device-secret": "设备密钥",
  "t-product-key": "产品密钥",
  "t-available": "可用",
  "t-used": "已使用",
  "t-current-version-deleted": "已删除",
  "t-available-list": "可用设备",
  "t-bound-list": "已绑定的设备",
  "t-selected-list": "已选设备",
  "t-select-device-bind": "请选择要绑定的设备",
  "t-batch": "批量",
  "t-upload": "上传",
  "t-refresh-device": "刷新设备",
  "t-remote-control": "远程控制",
  "t-remote-control-auto-pwd": "远程控制(自动输入密码)",
  "t-enable-unattended": "RCA 无人值守",
  "t-remote-control-approve-click": "授权连接",
  "t-remote-control-approve-password": "无人值守",
  "t-disable-remote-control": "禁用远程控制",
  "t-device-not-partner": "设备未绑定到合作伙伴",
  "t-remote-control-failed": "远程控制失败，请先取消霸屏模式",
  "t-health-check-failed-kiosk": "设备体检失败，请先取消霸屏模式",
  "t-remote-control-steps": "在远程控制连接设备中...",
  "t-disable-device": "禁用设备",
  "t-out-of-fence": "超出地理围栏",
  "t-active-statistics": "激活统计",
  "t-online-statistics": "在线统计",
  "t-active": "激活",
  "t-inactive": "未激活",
  "t-out-of-country": "超出国家地区围栏",
  "t-under-activation": "待激活",
  "t-online": "在线",
  "t-offline": "离线",
  "t-abnormal": "异常",
  "t-block": "拆机",
  "t-device-disabled": "设备禁用",
  "t-device-disabled-tamper": "设备禁用，拆机",
  "t-device-tamper-no": "设备正常",
  "t-device-tamper-yes": "设备被拆机",
  "t-filters": "高级查询",
  "t-basic-information": "基础信息",
  "t-installed-application": "设备已安装的应用",
  "t-last-factory-settings-time": "上次恢复出厂设置时间",
  "t-timeline": "推送任务记录",
  "t-android": "Android",
  "t-build-number": "系统版本",
  "t-sp-bootloader": "SP引导程序",
  "t-sma-version-code": "SMA版本",
  "t-version-code": "版本代码",
  "t-version-type": "版本类型",
  "t-upgrade-model": "升级模式",
  "t-sma-status": "SMA状态",
  "t-pubkey-status": "公钥状态",
  "t-cortex-scanner": "Cortex扫描仪",
  "t-total": "总计",
  "t-cpu-statistics": "CPU统计",
  "t-ram-statistics": "RAM统计",
  "t-storage-statistics": "存储统计",
  "t-authorisations": "授权",
  "t-kiosk-mode": "霸屏模式",
  "t-set-kiosk-mode": "设置霸屏模式",
  "t-cancel-kiosk-mode": "取消霸屏模式",
  "t-open-immediately": "立即打开",
  "t-options": "选项",
  "t-application-starts-automatically-after-installation": "应用程序安装完成后自动启动。",
  "t-cancel-open-immediately": "取消立即打开",
  "t-screen-resolution": "屏幕分辨率",
  "t-battery-capacity": "电池容量",
  "t-sim-number": "SIM号",
  "t-sp-firmware": "SP固件",
  "t-cpu": "CPU",
  "t-iccid": "ICCID - (SIM)",
  "t-production-batch": "生产批次",
  "t-category": "类别",
  "t-sales-batch": "销售批次",
  "t-network": "网络",
  "t-router-address": "路由器地址",
  "t-router-name": "路由器名称",
  "t-communication-type": "通信类型",
  "t-signal-strength": "信号强度",
  "t-transmission-speed": "传输速度",
  "t-wifi": "WIFI",
  "t-mobile": "Mobile",
  "t-wifi-mac-address": "WIFI的Mac地址",
  "t-push-mgmt": "推送管理",
  "t-rki-mgmt": "密钥管理",
  "t-partner": "合作伙伴",
  "t-parent": "父合作伙伴",
  "t-continent-region-exist": "相同的大陆和区域数据已存在。请删除现有数据，然后重新添加",
  "t-customer": "客户",
  "t-merchant": "商户",
  "t-store": "商店",
  "t-excel-sample-file": "Excel示例文件",
  "t-import-strip": "条",
  "t-number-of-successes": "成功数量",
  "t-number-of-failed": "失败数量",
  "t-import-failed-file": "导入失败的文件（点击下载）",
  "t-device-settings": "设备配置",
  "t-manufacturer": "设备供应商",
  "t-model": "设备型号",
  "t-model-version": "型号版本",
  "t-general": "通用版本",
  "t-beta": "灰度版本",
  "t-resolution": "分辨率",
  "t-connection-type": "连接方式",
  "t-message-protocol": "消息协议",
  "t-hardware-parameter": "硬件参数",
  "t-version": "版本",
  "t-version-list": "版本号",
  "t-json-layout": "JSON格式",
  "t-general-parameter": "系统通用参数",
  "t-terminal-profiles": "终端初始化文件",
  "t-force-initialization": "强制初始化",
  "t-group": "设备分组",
  "t-add-device-to-group": "将设备添加到组",
  "t-upload-file-bind-device": "上传文件和批量绑定/解绑设备",
  "t-geo-fence": "地理围栏",
  "t-erase-drawing": "删除图形",
  "t-log-capture": "日志抓取",
  "t-log": "日志",
  "t-firmware": "固件",
  "t-firmware-version": "固件版本",
  "t-md5": "MD5",
  "t-application-mgmt": "应用管理",
  "t-application": "应用",
  "t-application-name": "应用名称",
  "t-application-version": "应用版本",
  "t-application-certificates": "应用证书",
  "t-api-sign": "API 应用",
  "t-ft-applications": "飞天应用",
  "t-sign-status-created": "待上传",
  "t-sign-status-queued": "排队中",
  "t-sign-status-signing": "签名中",
  "t-sign-status-completed": "已完成",
  "t-sign-status-failed": "失败",
  "t-certificates": "证书",
  "t-certificate-level": "证书级别",
  "t-tls-certificates": "TLS证书",
  "t-certificate-version": "证书版本",
  "t-certificate-owner": "证书所有者",
  "t-certificate": "证书",
  "t-certificate-issuer": "证书颁发者",
  "t-subject-dn": "主体标识",
  "t-issuer-dn": "颁发者标识",
  "t-not-before": "生效时间",
  "t-not-after": "过期时间",
  "t-certificate-serial-number": "证书序列号",
  "t-certificate-effective-date": "证书生效日期",
  "t-certificate-expiration-date": "证书到期日期",
  "t-certificate-signing-algorithm": "证书签名算法",
  "t-batch-upload": "批量上传",
  "t-friendly-name": "证书名称",
  "t-name-common": "通用名称",
  "t-country": "国家",
  "t-currency": "货币",
  "t-city": "城市",
  "t-org-unit": "组织单位",
  "t-org": "组织",
  "t-state-province": "州/省",
  "t-common-name": "通用名称",
  "t-organization": "组织",
  "t-organizational-unit-name": "组织单元名称",
  "t-locality": "城市/地区",
  "t-key-store-password": "密钥库密码",
  "t-calendar": "日历",
  "t-transaction-param": "交易参数",
  "t-byte": "字节",
  "t-copy-code": "复制代码",
  "t-offline-data-authentication-was-not-performed": "未执行脱机数据身份验证",
  "t-sda-failed": "SDA 失败",
  "t-icc-data-missing": "ICC 数据丢失",
  "t-card-appears-on-terminal-exception-file": "卡出现在终端异常文件上",
  "t-dda-failed": "DDA失败",
  "t-cda-failed": "CDA 失败",
  "t-rfu": "RFU",
  "t-icc-and-terminal-have-different-application": "ICC和终端有不同的应用版本",
  "t-expired-application": "过期的应用",
  "t-application-not-yet-effective": "应用还未生效",
  "t-requested-service-not-allowed-for-card-product": "卡产品不允许请求的服务",
  "t-new-card": "新卡",
  "t-cardholder-verification-was-not-successful": "持卡人验证未成功",
  "t-unrecognised-cvm": "未识别的 CVM",
  "t-pin-try-limit-exceeded": "超过PIN尝试限制",
  "t-pin-entry-required-and-pin-pad-not-present-or-not-working": "需要输入PIN，PIN键盘不存在或不工作",
  "t-pin-entry-required-pin-pad-present-but-pin-was-not-entered": "需要输入PIN, PIN键盘存在,但是未输入PIN",
  "t-online-pin-entered": "已输入联机PIN",
  "t-transaction-exceeds-floor-limit": "交易超过下限",
  "t-lower-consecutive-offline-limit-exceeded": "超过连续脱机下限",
  "t-upper-consecutive-offline-limit-exceeded": "超过连续脱机上限",
  "t-transaction-selected-randomly-for-online-processing": "随机选择交易进行在线处理",
  "t-merchant-forced-transaction-online": "商户强制在线交易",
  "t-package": "包",
  "t-package-name": "包名称",
  "server.mam.ft.package.mismatch": "包名不符合",
  "t-application-token": "应用程序令牌",
  "t-client-token": "客户端令牌",
  "t-intent-name": "Intent名称",
  "t-file-name": "文件名",
  "t-file-size": "文件大小",
  "t-silent-upgrade": "自动升级",
  "t-prompt-for-upgrade": "手动升级",
  "t-upgrade-strategy": "升级策略",
  "t-upgrade": "升级",
  "t-upgrade-strategy-for-supports-sma": "升级策略只支持SMA, SMA版本100513及以上支持此升级策略",
  "t-allow-use-network-download": "允许使用移动网络下载",
  "t-selected-range-not-allowed": "选择时间区间不允许超过18个小时",
  "t-terminal-allow-use-network-download-network": "选择此选项,终端将允许使用移动网络下载固件文件",
  "t-time-period-upgrade-tip": "终端将在指定时间段内进行自动升级，如果终端取消此次升级后，将再下一个时间段内再次进入升级",
  "t-period-of-time": "时段",
  "t-start-time-and-end-time-cannot-be-same": "选择时间间隔不允许相同",
  "t-push-to-device-group": "推送到设备或组",
  "t-push-login-as-partner": "请以合作伙伴身份登录以执行此功能",
  "t-push-to-device": "推送到设备",
  "t-push-to-group": "推送到组",
  "t-push-report": "推送记录",
  "t-abort-push": "撤销推送",
  "t-not-start": "未开始",
  "t-warning-to-cancel-push": "您确定要撤销推送吗?",
  "t-scheduler-tasks": "推送计划任务",
  "t-planned": "计划",
  "t-message": "消息",
  "t-message-type": "消息类型",
  "t-push-message": "计划消息已过期",
  "t-showing-duration": "显示持续时间",
  "t-unlimited": "无限制",
  "t-plan-time": "计划时间",
  "t-message-from": "从",
  "t-every": "每",
  "t-content": "内容",
  "t-advertisement": "广告",
  "t-advertisement-planner": "广告计划",
  "t-push-advertisement-expired": "广告已过期",
  "t-planner": "计划",
  "t-advertisement-file": "资源文件",
  "t-loop": "循环",
  "t-ads-start-date": "广告开始日期和时间",
  "t-ads-end-date": "广告结束日期和时间",
  "t-more-detail-url": "更多详情URL",
  "t-detail-url": "详情URL",
  "t-folder": "文件夹",
  "t-key-capture": "生成密钥",
  "t-key": "密钥",
  "t-index": "索引",
  "t-algorithm": "算法",
  "t-key-type": "密钥类型",
  "t-number-keys": "密钥数量",
  "t-key-group": "密钥组",
  "t-key-value": "密钥值",
  "t-kcv": "KCV",
  "t-clear-key": "明文密钥",
  "t-encrypted-key-under": "加密密钥",
  "t-key-capture-report": "密钥生成记录",
  "t-key-injection": "密钥注入",
  "t-ksi": "KSI",
  "t-did": "DID",
  "t-counter": "计数器",
  "t-ksn": "KSN",
  "t-ksn-example": "KSN示例",
  "t-hsm": "HSM",
  "t-hsm-model": "HSM型号",
  "t-interface": "接口",
  "t-primary-host": "主机地址",
  "t-primary-port": "主机端口",
  "t-secondary-host": "辅助主机地址",
  "t-secondary-port": "辅助主机端口",
  "t-hsm-enable": "HSM是否启用",
  "t-lmk-index": "LMK索引",
  "t-enable": "是否开启",
  "t-key-block": "密钥块",
  "t-widgets": "插件",
  "t-settings": "设置",
  "t-device-locations": "设备位置",
  "t-role-widget-save-successfully": "授权列表保存成功",
  "t-partner-settings": "合作伙伴设置",
  "t-signature": "APK签名",
  "t-cloud-messaging": "云消息服务",
  "t-detamper-auth": "解除拆机验证",
  "t-enable-signature-error-partner-not-found": "无法启用二次签名，未关联合作伙伴",
  "t-enable-signature-error-2nd-cert-not-found": "无法启用二次签名，未找到二级证书",
  "t-partner-setting-updated-successfully": "合作伙伴设置更新成功！",
  "t-error-updating-partner-setting": "更新合作伙伴设置时发生错误",
  "t-error-loading-partner-setting": "加载合作伙伴设置时发生错误",
  "t-email-settings": "邮箱设置",
  "t-email": "邮箱",
  "t-email-server": "电子邮件服务器",
  "t-email-account": "电子邮件帐号",
  "t-port": "端口",
  "t-ssl": "SSL",
  "t-starttls": "STARTTLS",
  "t-email-sender": "电子邮件发送者",
  "t-sms-settings": "短信设置",
  "t-sms": "短信",
  "t-sms-gateway": "短信网关",
  "t-sms-settings-sms": "短信服务商",
  "t-sms-settings-signname": "签名名称",
  "t-access": "Access",
  "t-access-key-id": "Access Key ID",
  "t-access-key-secret": "Access Key Secret",
  "t-password-policy": "密码策略",
  "t-enable-password-policy": "启用密码策略",
  "t-enable-password-length-minimum": "启用密码最短长度",
  "t-password-length": "最短密码长度的范围是4-32",
  "t-required-item": "此项为必填项",
  "t-password-length-minimum": "最小值为4",
  "t-password-length-maximum": "最大值为32",
  "t-password-policy-pattern": "此值必须为整数",
  "t-enable-password-part": "启用密码组成方式",
  "t-password-numbers-and-letters-combination": "密码应为数字和字母的组合",
  "t-password-use-least-one-uppercase-letter": "至少使用一个大写字母",
  "t-repeated-characters-not-allowed-to-use": "禁止使用重复字符",
  "t-allows-use-special-characters": "允许使用特殊字符（空格除外）",
  "t-use-least-one-special-character": "至少使用一个特殊字符",
  "t-different-user-name-and-password": "用户名和密码必须不同",
  "t-whether-to-enable-history-password": "是否禁止使用历史密码",
  "t-use-history-password-number": "不允许使用历史密码个数 [值为3-6]",
  "t-use-history-password-number-minimum": "最小值是3",
  "t-use-history-password-number-maximum": "最大值是6",
  "t-enable-password-change-frequency": "是否启用密码更改频率",
  "t-password-change-frequency": "密码更改频率（天/1次）[值为1-9]",
  "t-password-change-frequency-minimum": "最小值是1",
  "t-password-change-frequency-maximum": "最大值是9",
  "t-change-the-password-regular-basis": "是否定期更改密码",
  "t-password-periodically-change": "定期更改密码时间（天数）[值为90-365]",
  "t-password-periodically-minimum": "最小值是90",
  "t-password-periodically-maximum": "最大值是365",
  "t-password-configuration-updated-successfully": "密码策略已更新成功！",
  "t-error-updated-password-configuration": "密码策略更新失败",
  "t-times-task": "定时任务设置",
  "t-execute-once": "执行一次",
  "t-task-group": "任务组",
  "t-method": "方法",
  "t-log-information": "日志信息",
  "t-cron-expression": "Cron表达式",
  "t-clean-condition": "清除条件",
  "t-concurrent": "并发",
  "t-wrong-strategy": "错误策略",
  "t-allow": "允许",
  "t-prohibit": "禁止",
  "t-execute-immediately": "立即执行",
  "t-next-execution-time": "下次执行时间",
  "t-execute": "执行",
  "t-cancel-execution": "取消执行",
  "t-task-scheduler": "系统定时任务",
  "t-task-scheduler-logs": "系统定时任务执行记录",
  "t-notice": "通知设置",
  "t-alarm-settings": "通知报警设置",
  "t-alarm": "告警",
  "t-alarm-mgmt": "告警管理",
  "t-already-used": "已使用",
  "t-silence-time": "静默时间",
  "t-alert-logs": "报警日志",
  "t-logs": "日志",
  "t-alert-status-info-untreated": "未处理",
  "t-alert-status-info-processed": "已处理",
  "t-alert-status-info-closed": "已关闭",
  "t-alert-status-info-handle": "处理",
  "t-alert-status-info-close": "关闭",
  "t-rule": "规则",
  "t-alert-policies": "报警策略",
  "t-policies": "策略",
  "t-alert-level": "报警级别",
  "t-level": "级别",
  "t-alerts-cycles": "报警周期",
  "t-alert-channel": "报警渠道",
  "t-contacts-group": "联系人组",
  "t-contacts-user": "联系人",
  "t-alert-rule": "报警规则",
  "t-email-alert-template": "邮件报警模板",
  "t-email-template": "邮件模板",
  "t-alert-rule-template": "规则模板",
  "t-template-title": "模板标题",
  "t-template": "模板",
  "t-from-name": "发件人姓名",
  "t-email-alert-content": "邮件模板内容",
  "t-search-alert": "搜索通知名称",
  "t-alert-notice": "报警通知",
  "t-alert-policy": "报警策略",
  "t-policy": "策略",
  "t-alert-contacts": "报警联系人",
  "t-alert-start-time": "生效时间",
  "t-alert-mechanism": "报警机制",
  "t-notice-channels": "通知渠道",
  "t-channels": "渠道",
  "t-first-sequence-notifier": "第一序列通知人",
  "t-second-sequence-notifier": "第二序列通知人",
  "t-third-sequence-notifier": "第三序列通知人",
  "t-notification-interval": "下一次通知间隔",
  "t-error-sms-not-enable": "没有已启用的短信网关配置",
  "t-error-email-not-enable": "没有已启用的邮箱配置",
  "t-enable-fence-alert": "启用围栏报警",
  "t-policy-alert-rule-content": " 报警规则",
  "t-alert-channel-template-configuration": "报警渠道模板配置",
  "t-available-merge-fields": "可用合并字段",
  "t-sunday": "星期日",
  "t-monday": "星期一",
  "t-tuesday": "星期二",
  "t-wednesday": "星期三",
  "t-thursday": "星期四",
  "t-friday": "星期五",
  "t-saturday": "星期六",
  "t-notifying-user": "通知用户",
  "t-notifying-partner": "通知合作伙伴",
  "t-notifying-customer": "通知客户",
  "t-notifying-merchat": "通知商户",
  "t-notifying-text-message": "短信",
  "t-notifying-info": "通知信息",
  "t-alert-status": "通知状态",
  "t-alert-time": "报警时间",
  "t-ui": "UI",
  "t-wallpaper": "壁纸",
  "t-boot-picture": "开机第一帧",
  "t-boot-animation": "开机动画",
  "t-log-report": "日志与报表",
  "t-entity-value": "实体值",
  "t-system-health": "系统健康",
  "t-gateway": "网关",
  "t-configuration": "配置",
  "t-health": "健康",
  "t-audit-logs": "审计日志",
  "t-tickets": "工单",
  "t-disconnect": "断开",
  "t-received": "收到",
  "t-unreceived": "未收到",
  "t-subject": "主题",
  "t-user-mgmt": "用户管理",
  "t-user": "用户",
  "t-authorities": "角色",
  "t-reset-password": "重置密码",
  "t-activate-token": "激活双因子认证",
  "t-replace-token": "更换双因子认证",
  "t-activate-user": "启用用户",
  "t-activate": "启用",
  "t-deactivate": "关闭",
  "t-reboot": "重启",
  "t-warning-to-reboot": "您确定要重启设备吗？",
  "t-warning-to-unbind": "确定要解绑此项记录吗？",
  "t-lock": "锁定",
  "t-lock-device": "锁定设备",
  "t-warning-to-lock": "您确定要锁定设备吗？",
  "t-unlock": "解锁",
  "t-warning-to-unlock": "您确定要解锁设备吗？",
  "t-factory-settings": "恢复出厂设置",
  "t-warning-to-reset": "您确定要将设备恢复为出厂设置吗？此操作将导致数据丢失您确定吗？",
  "t-warning-to-shut-down": "您确定要关闭设备吗？",
  "t-warning-to-disable-geo-tracking": "您确定要禁用地理跟踪吗？",
  "t-shut-down-device": "关机",
  "t-enable-geo-tracking": "启用地理跟踪",
  "t-disable-geo-tracking": "禁用地理跟踪",
  "t-warning-to-geo-tracking": "请注意，启用地理跟踪会导致电池电量消耗",
  "t-device-geo-tracking-not-enable": "设备未启用地理跟踪",
  "t-device-geo-tracking-has-enable": "设备已启用地理跟踪",
  "t-enter-package-name": "输入包名",
  "t-package-name-already-exists": "该包名已存在",
  "t-duplicate-package-name-warning": "发现重复的包名：",
  "t-duplicate-package-name-error": "请移除重复的包名：",
  "t-device-sn": "设备序列号",
  "t-device-name": "设备名称",
  "t-device-license-file-does-not-exist": "设备许可文件不存在",
  "t-device-under-activation": "设备处于待激活或者未激活状态",
  "t-device-is-out-of-range-activation-failed": "设备超出范围，激活失败",
  "t-sync": "同步",
  "t-cancel-geo-fencing": "取消地理围栏",
  "t-warning-to-cancel-geo-fencing": "您确定要取消地理围栏吗？",
  "t-device-not-support-pubkey-synchronization": "设备不支持公钥同步，请检查设备",
  "t-device-geo-location": "设备地理位置",
  "t-geo-location": "地理位置",
  "t-longitude": "经度",
  "t-latitude": "纬度",
  "t-device-unbind-successful": "设备解绑成功",
  "t-device-bind-successful": "设备绑定成功",
  "t-wait-pend": "进行中，请等待设备响应",
  "t-warning-to-activate-kiosk": "您确定要开启霸屏模式吗？",
  "t-setting-version-type-general": "如果此版本设置为通用版本，则以下应用将被修改为灰度版本",
  "t-error-application-not-function": "系统应用程序无法执行此操作",
  "t-error-device-no-application": "在设备上没有此应用程序",
  "t-warning-to-deactivate-kiosk": "您确定要关闭霸屏模式吗？",
  "t-device-need-specified-area": "该设备需要返回指定区域",
  "t-device-need-specified-fence": "该设备需要返回指定的围栏",
  "t-recover-key-success": "发送设备初始化密钥请求成功",
  "t-error-domineering-state-already": "已经有其他应用处于霸屏状态",
  "t-app-has-dominated": "此应用已经被霸屏，请不要再发送霸屏指令",
  "t-error-app-not-domineering-state": "该应用不处于霸屏状态",
  "t-error-device-not-app-in-dominant-state": "该设备没有处于霸屏状态的应用",
  "t-error-current-domineering-state-already": "当前的应用程序已经处于主导的屏幕状态",
  "t-warning-to-uninstall": "您确定要卸载应用程序",
  "t-warning-to-uninstall-block": "您确定要移除禁止卸载应用？",
  "t-application-in-kiosk-mode": "应用处于霸屏模式，请先解除霸屏模式",
  "t-uninstall-application": "卸载应用程序",
  "t-device-not-activated": "设备未激活",
  "t-device-not-online": "设备没有在线",
  "t-request-sent-device": "请求已成功发送到设备",
  "t-activate-request-sent": "成功向设备发送激活请求",
  "t-error-updating-device": "更新设备时发生错误",
  "t-storm-restore-factory-settings": "STORM - 恢复出厂设置",
  "t-device-restore-factory-settings": "Device - 恢复出厂设置",
  "t-first-name": "名字",
  "t-last-name": "姓氏",
  "t-deactivated": "停用",
  "t-activated": "激活",
  "t-role": "角色",
  "t-permissions-name-connot-replace": "名称格式不匹配，名称不能等于“ROLE_ADMIN”、“ROLE_OPERATOR”、“ROLE_PARTNER”或“ROLE_USER”中的任何一个.",
  "t-auto-generate-password": "自动生成密码",
  "t-deactivate-user": "禁用用户",
  "t-role-permissions": "角色权限",
  "t-permissions": "权限",
  "t-read": "读",
  "t-write": "写",
  "t-push": "推送",
  "t-record": "记录",
  "t-tid": "TID",
  "t-mid": "MID",
  "t-imei": "IMEI",
  "t-disable": "超出国家地区围栏",
  "t-tamper": "拆机",
  "t-de-tamper": "解除拆机",
  "t-report": "报表",
  "t-report-data": "报表数据",
  "t-report-settings": "报表设置",
  "t-report-download": "报表下载",
  "t-sort-digit": "排序数字",
  "t-universal": "通用",
  "t-widget": "控件",
  "t-conditions": "条件",
  "t-attribute-code": "属性代码",
  "t-attribute-name": "属性名称",
  "t-attribute": "属性",
  "t-data-type": "数据类型",
  "t-attribute-type": "属性类型",
  "t-language-type": "语言类型",
  "t-enumerated-value": "枚举值",
  "t-enumerated-name": "枚举名称",
  "t-association": "关联",
  "t-sql": "SQL",
  "t-chart": "图形",
  "t-pie-chart": "饼图",
  "t-bar-chart": "柱状图",
  "t-line-chart": "折线图",
  "t-time-frame": "时间范围",
  "t-enumeration": "枚举",
  "t-string": "字符串",
  "t-internationalization": "国际化",
  "t-language": "语言",
  "t-charts": "图表",
  "t-fixed-report": "静态报表",
  "t-dynamic-report": "动态报表",
  "t-reason": "原因",
  "t-numbers-letter": "由大写和小写字母、数字和横线组成",
  "t-input-invalid-pattern-default": "由数字、字母、下划线、点和空格组成，支持中文、英文、法语、俄语和西班牙语，不能以空格开头或结尾",
  "t-input-invalid-pattern-default-arabic": "由数字、字母、下划线、点和空格组成，支持中文、英文、法语、俄语、西班牙语和阿拉伯语，不能以空格开头或结尾",
  "t-input-invalid-pattern-user-name": "由数字、字母、横线和空格组成，支持中文、英文、法语、俄语和西班牙语，不能以空格开头或结尾",
  "t-input-invalid-pattern-phone": "由数字、横线、+和空格组成，不能以空格或横线开头和结尾。空格和横线不能连续输入，带区号的号码以+或00开头",
  "t-input-invalid-pattern-website": "以URL格式组成",
  "t-input-invalid-pattern-host": "以IP地址格式组成",
  "t-input-invalid-pattern-email": "邮件格式示例:abc@ftsafe.com",
  "t-input-invalid-pattern-smtp": "以SMTP域名格式组成",
  "t-input-invalid-pattern-sn": "由大写和小写字母、数字和横线组成",
  "t-input-invalid-pattern-imei": "由纯数字组成",
  "t-input-invalid-pattern-device-imei": "IMEI只能输入数字",
  "t-input-invalid-pattern-tid": "由大写和小写字母和数字组成",
  "t-input-invalid-pattern-key": "由大写字母和小写字母、点和数字组成",
  "t-input-invalid-pattern-key-number": "由大写字母和小写字母、点组成",
  "t-input-invalid-pattern": "请输入有效值。请注意开头和结尾字符不能是空格",
  "t-input-invalid-pattern-password": "请输入有效值。至少包含一个数字或字母。请注意开头和结尾字符不能是空格",
  "t-input-invalid-pattern-letters-numbers": "只允许输入字母和数字",
  "t-minlength-valid-pattern": "最小字符限制为",
  "t-maxlength-valid-pattern": "最大字符限制为",
  "t-file-maximum-size": "文件大小最大是",
  "t-file-upload-right-spec": "请上传符合要求的文件",
  "t-model-name": "型号名称",
  "t-log-info": "日志信息",
  "t-clean-success": "清除成功",
  "t-push-event-id": "推送事件ID",
  "t-operation": "操作",
  "t-input-password-mismatch": "密码不匹配",
  "t-generated": "生成",
  "t-entity": "实体",
  "t-entity-name": "实体名称",
  "t-minutes": "分钟",
  "t-hours": "小时",
  "t-app-incremental-upgrade": "应用程序增量升级",
  "t-restart": "重启",
  "t-shutdown-device": "设备关机",
  "t-system-parameter": "系统参数",
  "t-start": "开始",
  "t-end": "结束",
  "t-stop": "停止",
  "t-time": "时间",
  "t-geo-fencing": "地理围栏",
  "t-initialization": "初始化",
  "t-erase": "解除",
  "t-initial-key": "初始化密钥",
  "t-geo-tracking": "地理跟踪",
  "t-automatic": "自动",
  "t-sma-data-synchronization": "SMA数据同步",
  "t-pubkey-synchronization": "公钥同步",
  "t-push-select-device-group": "请选择需要推送的设备或组",
  "t-m20-transaction-param": "M20交易参数",
  "t-push-status-push-sent": "推送已发送",
  "t-push-status-push-received": "推送已接收",
  "t-push-status-downloading": "下载中",
  "t-push-status-installing": "安装中",
  "t-push-status-executing": "执行中",
  "t-push-status-success": "成功",
  "t-push-status-fail": "失败",
  "t-push-status-app-not-signed": "失败，应用程序未签名",
  "t-push-status-install-later": "稍后安装",
  "t-push-status-higher-version-exist": "失败，应用程序存在更高版本",
  "t-push-status-app-not-installed": "失败，应用程序未安装",
  "t-push-status-broadcast-transmitted": "广播已传输",
  "t-push-status-increment-file-error": "失败，增量文件错误",
  "t-push-status-file-format-error": "失败，文件格式错误",
  "t-push-status-download-file-error": "失败，下载文件错误",
  "t-push-status-task-reached-the-maximum": "失败，任务达到最大值",
  "t-push-status-insufficient-electricity": "失败，电量不足，请稍后再试",
  "t-push-status-app-patch-updating": "应用程序补丁更新",
  "t-push-status-app-patch-update-error": "失败，应用程序补丁更新错误",
  "t-push-status-parameter-error": "失败，参数错误",
  "t-push-status-download-completed": "下载完成",
  "t-push-status-same-task-exist": "失败，存在相同的任务",
  "t-push-status-push-uploading": "推送上传中",
  "t-push-status-push-ota-file-mismatch": "失败，推送OTA文件不匹配",
  "t-push-status-start-capture": "开始抓取",
  "t-push-status-stop": "停止",
  "t-push-status-key-parameter-error": "失败，密钥参数错误",
  "t-push-status-already-activated": "已激活",
  "t-push-status-no-space-left-on-device": "失败，设备存储空间不足",
  "t-push-status-initkey-failed": "解除拆机告警成功，但初始化密钥失败",
  "t-push-status-erase-tamper-failed": "失败，解除拆机告警失败",
  "t-push-status-close-2nd-sig-failed": "失败，关闭二次签名失败",
  "t-push-status-open-2nd-sig-failed": "失败，打开二次签名失败",
  "t-push-status-verify-2nd-sig-cert-failed": "失败，验证二次签名证书失败",
  "t-push-status-push-to-pulsar-failed": "失败，推送到Pulsar失败",
  "t-push-status-push-to-mpush-failed": "失败，推送到Mpush失败",
  "t-push-status-status-push-sp-server-is-busy": "SP服务器繁忙 ",
  "t-push-status-reverted": "撤销",
  "t-push-status-factory-setting-cause-no-log": "失败，恢复出厂设置导致无日志记录",
  "t-push-status-md5-verification-failed": "失败，MD5验证失败",
  "t-push-status-device-offline": "设备离线，请稍后重试",
  "t-push-status-mpush-push-to-device-fail": "Mpush推送到设备失败，请稍后重试",
  "t-push-status-download-completed-wait-for-upgrade": "下载完成，等待升级",
  "t-push-status-push-event-has-been-fetched": "推送事件已获取",
  "t-push-status-get-push-event-fail": "失败，获取推送事件失败",
  "t-push-status-apk-install-failed-invalid": "失败，推送APK无效",
  "t-push-status-apk-install-failed-system-mistake": "失败，安装APK时系统错误",
  "t-push-status-apk-install-failed": "失败，APK安装时SD卡异常或存储不足",
  "t-push-status-apk-install-failed-certificate-mistake": "失败，安装APK时证书错误",
  "t-push-status-apk-install-failed-other": "失败，安装APK失败，其他原因",
  "t-push-status-init-key-failed": "失败，初始化密钥失败",
  "t-push-status-kiosk-mode-in-progress": "失败，设备处于霸屏",
  "t-push-status-network-issue": "失败，网络问题，请稍后再试",
  "t-push-status-network-failed": "失败，设备网络状态异常",
  "t-push-status-unsupported-action": "失败，设备不支持的业务",
  "t-push-status-initialization-interupted": "失败，初始化中断",
  "t-push-status-cert-install-failed": "失败，证书安装失败",
  "t-push-status-apk-install-failed-device-os-version-not-support": "失败，OS版本不支持V2签名",
  "t-push-status-invalid-apk-file-caused-signature-failure": "失败，无效的APK文件导致的签名失败",
  "t-push-status-device-unusual-status-unactive": "失败，设备未激活",
  "t-push-status-device-unusual-status-geoFence": "失败，设备超出地理围栏",
  "t-push-status-device-unusual-status-regionOut": "失败，设备超出国家地区围栏",
  "t-push-status-device-unusual-status-tamper": "失败，设备处于拆机状态",
  "t-push-status-device-unusual-status-regionOut-tamper": "失败，设备超出国家地区围栏，并且处于拆机状态",
  "t-push-status-device-unusual-status-region-geoFence": "失败，设备超出国家地区围栏和地理围栏",
  "t-push-status-device-unusual-status-under-activation": "失败，设备处于待激活状态",
  "t-push-status-app-not-enable-kiosk-mode": "失败，未启用霸屏模式",
  "t-push-status-device-region-geoFence-tamper": "失败，设备超出国家地区围栏、处于拆机异常状态和超出地理围栏",
  "t-push-status-device-geoFence-tamper": "失败，设备超出地理围栏和处于拆机异常状态",
  "t-push-status-push-has-expired-please-try-again": "推送任务过期，请重试",
  "t-push-status-public_key_no_mismatch": "设备公钥不匹配",
  "t-push-status-device-upgrading": "失败，本次任务因设备正在升级而无法执行。",
  "t-push-status-sp-unavailable-state": "失败，SP处于不可用状态。",
  "t-data-exception-sync-completed": "数据异常，同步已完成",
  "t-data-is-normal-no-need-to-sync": "数据正常，无需同步",
  "t-pubkey-uploaded": "公钥上传",
  "t-pubkey-exception-sync-completed": "公钥异常，同步已完成",
  "t-system-param-version": "系统参数版本",
  "t-profile": "配置文件",
  "t-profile-details": "配置文件详细信息",
  "t-wallpaper-file": "壁纸文件",
  "t-picture-file": "开机第一帧文件",
  "t-animation-file": "开机动画文件",
  "t-server-mfm-picture-resolution-not-match": "上传失败，压缩包中的图片分辨率不匹配！",
  "t-server-mfm-picture-format-not-match": "上传失败，压缩包中的图片格式不匹配！",
  "t-server-mfm-boot-animatio-upload-failed": "上传失败，zip文件内容不符合开机动画图片规则！",
  "t-server-mfm-resolution-and-model-version-not-match": "上传失败，文件的分辨率和格式与型号版本不匹配！",
  "t-key-capture-records-status-hsm-error": "HSM错误",
  "t-key-capture-records-status-kcv-value-error": "KCV键值错误",
  "t-date-range-90-day": "选择的日期范围不能超过90天",
  "t-select-start-end-time": "必须选择开始时间和结束时间",
  "t-In Progress": "进行中",
  "t-Approved": "批准",
  "t-action-type": "操作类型",
  "t-client": "客户端",
  "t-client-ip": "客户端IP地址",
  "t-add.profile.check.application": "确保APK签名成功",
  "t-select.identical.application": "您选择了重复的应用程序",
  "t-log-details": "操作对象描述",
  "t-key-capture-records-status-public-key-not-exist": "设备公钥不存在",
  "t-log-capture-not-start": "抓取未开始",
  "t-log-capture-completed": "抓取完成",
  "t-log-capture-failed": "抓取失败",
  "t-log-capture-capturing": "抓取中",
  "t-plaintext": "明文",
  "t-cipher": "密文",
  "t-bdk-lmk": "BDK / LMK",
  "t-error-match-password": "两次密码不一致",
  "t-ui-settings": "UI设置",
  "t-license-mgmt": "授权管理",
  "t-license": "授权",
  "t-license-settings": "授权设置",
  "t-tamper-authorization-times": "拆机授权次数",
  "t-number-assignable-authorizations": "可转让授权的数量",
  "t-license-information": "授权用户",
  "t-allocate-authorization": "分配授权",
  "t-add-allocate-authorization": "增加分配授权",
  "t-edit-allocate-authorization": "编辑分配授权",
  "t-authorization-times": "授权次数",
  "t-remaining-times": "剩余次数",
  "t-enter-authorization.times": "输入授权次数",
  "t-email-use-for-code": "接收OTP验证码的邮箱",
  "t-allocate-authorization-created-successfully": "创建分配授权 {param} 成功！",
  "t-allocate-authorization-updated.successfully": "更新分配授权 {param} 成功！",
  "t-allocate-authorization-updated-times-successfully": "更新分配授权次数成功！",
  "t-error-allocate-authorization-created": "创建分配授权时发生错误",
  "t-error-allocate-authorization-updated": "更新分配授权时发生错误",
  "t-error-allocate-authorization-updated.times": "更新分配授权次数时发生错误",
  "t-correct": "正确",
  "t-check-kcv-values": "请输入两个值",
  "t-adb-enable": "ADB",
  "t-bluetooth-enable": "蓝牙",
  "t-mobile-data-enable": "移动数据",
  "t-nfc-enable": "NFC",
  "t-hot-spot-enable": "热点",
  "t-on": "ON",
  "t-off": "OFF",
  "t-no-content-selected": "未选择任何内容",
  "t-m": "分钟",
  "t-action-list": "操作列表",
  "t-key-capture-records-sn-repeatedly": "SN不能重复导入",
  "t-key-capture-records-sn-empty": "SN不能为空，序列号只能输入字母、数字和横杠",
  "t-key-capture-records-key-value-empty": "KEY VALUE 不能为空",
  "t-key-capture-records-kcv-empty": "KCV 不能为空",
  "t-key-capture-records-device-not-exist": "当前条件下未找到该设备",
  "t-key-capture-records-sn-not-bound-partner": "SN尚未绑定到合作伙伴",
  "t-key-capture-records-device-not-belong-user": "该设备不属于当前用户",
  "t-key-capture-records-device-not-activated": "设备未激活",
  "t-key-capture-records-key-applied-device-model": "密钥不能应用于此设备型号",
  "t-key-capture-records-failed-verify-countries-currencies": "未能验证相关国家和货币",
  "t-key-capture-records-tid-format-mismatch": "TID格式不匹配",
  "t-key-capture-records-tid-repeated": "TID已重复",
  "t-key-capture-records-tid-not-match-country-region": "TID数量国家/地区数量和货币数量不匹配",
  "t-key-capture-records-country-currency-not-empty": "国家和货币不能为空，因为TID不为空",
  "t-key-capture-records-tid-not-empty": "国家/地区或货币不为空TID不能为空",
  "t-key-capture-records-kcv-keyvalue-mismatch": "KCV键值不匹配",
  "t-expiry-date": "过期时间",
  "t-papers-available": "不缺纸",
  "t-out-of-papers": "缺纸或者不支持",
  "t-lack-of-paper": "是否缺纸",
  "t-bind-device-information-details": "绑定设备信息详细信息",
  "t-unbind-device-information-details": "解绑设备信息详细信息",
  "t-device-has-been-bind-partner-file": "设备已绑定合作伙伴文件(点击下载)",
  "t-device-bind-confirm-info": "此设备已绑定到合作伙伴。是否确实要将其绑定到",
  "t-role-type": "角色类型",
  "t-user-type": "用户类型",
  "t-user-source": "用户来源",
  "t-json": "JSON",
  "t-excel": "Excel",
  "t-release-notes": "发布说明",
  "t-cloud-message": "云消息",
  "t-select-duration": "选择过期范围",
  "t-onboard-merchants": "注册商户",
  "t-access-key": "访问密钥",
  "t-notifications": "通知",

  "t-signIn": "登录",
  "t-email-userName": "电子邮件/用户名",
  "t-forgot-password": "忘记密码",
  "t-devices": "设备",
  "t-manufacturer-name": "厂商名称",
  "t-manipulate": "操作",
  "t-firmwares": "固件",
  "t-applications": "应用程序",
  "t-group-management": "组管理",
  "t-key-capture-event-id": "密钥生成事件ID",
  "t-key-capture-records": "密钥生成记录",
  "t-key-capture-records-details": "密钥生成记录详情",
  "t-search-key-capture-records-details": "搜索记录详情",
  "t-key-capture-records-status-success": "成功",
  "t-key-configuration": "密钥配置",
  "t-status-check": "状态检查",
  "t-device-selection": "设备选择",
  "t-complete": "完成",
  "t-existing-records-found": "检测到已存在 {count} 条记录，最后一条 Key：",
  "t-add-device-key": "追加到最后一条记录",
  "t-add-device-key-tooltip": "将新的密钥追加到已存在的最后一条记录中",
  "t-regenerate-overwrite": "重新生成",
  "t-regenerate-overwrite-tooltip": "重新生成密钥，将覆盖原有记录",
  "t-key-new-title": "新密钥",
  "t-key-new-description": "这是一个新的密钥配置，可以直接创建。",
  "t-key-exists-title": "密钥已存在",
  "t-key-exists-description": "检测到已存在相同配置的密钥记录。",
  "t-historical-records": "历史记录",
  "t-no-key-record": "没有密钥记录",
  "t-select-devices": "选择设备",
  "t-captured": "已捕获",
  "t-uncaptured": "未捕获",
  "t-pubkey-changed": "公钥已变更",
  "t-operation-option": "操作选项",
  "t-operation-success": "操作成功",
  "t-key-capture-complete": "密钥生成完成",
  "t-view-report": "查看报告",
  "t-capture-another": "继续生成",
  "t-file-management": "文件管理",
  "t-ads-reporter": "广告推送记录",
  "t-push-scheduler": "推送计划任务",
  "t-device-import": "设备导入",
  "t-manufacturer-import": "厂商导入",
  "t-partner-import": "合作伙伴导入",
  "t-customer-import": "客户导入",
  "t-merchant-import": "商户导入",
  "t-store-import": "商店导入",
  "t-key-import": "密钥导入",
  "t-device-upstream": "设备上传",
  "t-device-downstream": "设备下载",
  "t-user-management": "用户管理",
  "t-roles-permissions": "角色权限",
  "t-brands": "HSM",
  "t-ui-management": "UI管理",
  "t-system-params": "系统参数",
  "t-keys-management": "密钥管理",
  "t-media": "媒体",
  "t-import-mgmt": "导入管理",
  "t-log-mgmt": "日志管理",
  "t-system-mgmt": "系统管理",
  "t-add-device": "添加设备",
  "t-edit-device": "编辑设备",
  "t-placeholder-enter-sn": "输入序列号",
  "t-error-enter-sn": "序列号名称是必填项",
  "t-error-enter-valid-sn": "序列号只允许输入大写和小写字母、数字和横杠",
  "t-error-enter-valid-tid": "TID只允许输入大写和小写字母、数字和横杠",
  "t-error-enter-minlength-sn": "序列号长度不能小于2",
  "t-error-enter-minlength-tid": "TID长度不能小于2",
  "t-placeholder-enter-imei": "输入IMEI",
  "t-update-imei-successfully": "IMEI更新成功",
  "t-error-enter-imei": "IMEI是必填项",
  "t-error-enter-minlength-imei": "IMEI长度不能小于2",
  "t-error-enter-valid-imei": "IMEI只能输入数字",
  "t-error-enter-valid-pusheventid": "推送事件ID只能输入数字",
  "t-placeholder-enter-tid-name": "输入TID名称",
  "t-error-enter-tid-name": "TID名称是必填项",
  "t-error-model-version-required": "型号版本是必填项",
  "t-save-changes": "保存更改",
  "t-saving": "保存",
  "t-search-by-model-name": "按型号名称搜索",
  "t-search-device": "搜索设备",
  "t-bind-devices": "绑定设备",
  "t-unbind-devices": "解绑设备",
  "t-export-to-excel": "导出到Excel",
  "t-select-model-version": "型号版本",
  "t-search-by-name": "按名称搜索",
  "t-all": "全部",
  "t-search-selected-device": "搜索已选择的设备",
  "t-search-available-device": "搜索可用设备",
  "t-required-partner": "合作伙伴是必填项",
  "t-enter-manufacturer": "输入厂商名称",
  "t-loading-dashboard": "正在加载仪表板模块",
  "t-signing-in": "正在登录",
  "t-error-manufacturer-required": "厂商名称是必填项",
  "t-enter-website": "输入网址",
  "t-error-url-required": "请输入有效的URL",
  "t-select-logo": "选择标志",
  "t-add-manufacturer": "添加厂商",
  "t-edit-manufacturer": "编辑厂商",
  "t-error-loading-category": "加载类别时发生错误",
  "t-error-loading-group": "加载组时发生错误",
  "t-error-loading-production-batch": "加载生产批次时发生错误",
  "t-error-loading-sales-batch": "加载销售批次时发生错误",
  "t-error-loading-model-version": "加载型号版本时发生错误",
  "t-error-loading": "加载出错",
  "t-timeline-device-title": "设备生命周期",
  "t-device-created-successfully": "设备{sn}创建成功！",
  "t-error-created-device": "添加设备时发生错误",
  "t-device-updated-successfully": "设备{sn}更新成功！",
  "t-error-updated-device": "更新设备时发生错误",
  "t-package-name-required": "包名称是必填项",
  "t-submit-kiosk": "提交",
  "t-uninstall-app": "卸载应用程序",
  "t-uninstall-application-successfully": "应用程序卸载成功",
  "t-error-occurred": "发生错误",
  "t-no-data-avaliable": "没有可用数据",
  "t-no-data": "没有数据",
  "t-no-data-selected": "未选择数据",
  "t-no-firmware-version-in-folder": "该固件文件夹下暂无可用固件版本",
  "t-lat": "纬度",
  "t-lng": "经度",
  "t-device-out-of-region": "此设备已超出区域，请检查设备所在区域",
  "t-android-security-level": "Android安全级别",
  "t-system-type": "系统类型",
  "t-google-play-system-update": "Google Play系统更新",
  "t-technical-details": "技术细节",
  "t-en": "EN",
  "t-android-version": "Android 版本",
  "t-base-band-version": "基带版本",
  "t-battery-usage": "电池使用率",
  "t-cpu-usage": "CPU使用率",
  "t-emv-kernel-version": "EMV内核版本",
  "t-express-pay-kernel-version": "Express Pay内核版本",
  "t-ifm-module-name-version": "接触卡库版本",
  "t-jspeedy-kernel-version": "JSpeedy内核版本",
  "t-bootloader": "引导程序",
  "t-kernel-version": "内核版本",
  "t-pay-pass-kernel-version": "Pay Pass内核版本",
  "t-pay-wave-kernel-version": "Pay Wave内核版本",
  "t-pcd-module-name-version": "非接触卡器库版本",
  "t-platform-type": "平台类型",
  "t-printer-density": "打印机灰度",
  "t-quics-kernel-version": "QUICS内核版本",
  "t-ram": "内存",
  "t-ram-usage": "内存使用率",
  "t-screen-density": "屏幕密度",
  "t-storage": "存储",
  "t-storage-usage": "存储使用情况",
  "t-cortex-scanner-version": "Cortex扫描仪版本",
  "t-signal-type": "信号类型",
  "t-telecom-operators": "运营商",
  "t-tamper-operation": "双击解除拆机告警操作",
  "t-network-status": "网络状态",
  "t-system-status": "系统状态",
  "t-gb": "GB)",
  "t-device-activated-successfully": "设备激活成功！",
  "t-check-device-status": "请检查设备是否正常工作",
  "t-error-device-updated": "设备状态更新失败",
  "t-device-status-updated-successfully": "设备状态更新成功",
  "t-clear-tamper": "请先清除拆机告警",
  "t-model-created-successfully": "型号{sn}创建成功！",
  "t-model-updated-successfully": "型号{sn}更新成功！",
  "t-model-deleted-successfully": "型号{param}删除成功！",
  "t-error-creating-model": "添加型号时发生错误",
  "t-error-loading-model": "加载型号时发生错误",
  "t-error-loading-manufacturers": "加载厂商时发生错误",
  "t-error-loading-manufacturer": "加载厂商时发生错误",
  "t-add-model": "添加型号",
  "t-collapse": "收起",
  "t-restore": "恢复",
  "t-no-result-found": "未找到结果",
  "t-search-model": "型号",
  "t-search-manufacturer": "厂商",
  "t-enter-model-name": "输入型号名称",
  "t-model-name-required": "型号名称是必填项",
  "t-manufacturer-required": "厂商是必填项",
  "t-model-deleted ": "型号删除成功",
  "t-error-deleting-model": "删除型号时发生错误",
  "t-add-model-version": "添加型号版本",
  "t-edit-model-version": "编辑型号版本",
  "t-image-upload": "图片上传",
  "t-please-upload": "请上传图片",
  "t-maximum-file-size": "文件大小应不超过300 KB",
  "t-maximum-file-size-6m": "文件大小应不超过6 MB",
  "t-please-upload-file-type": "请上传bin、zip类型文件",
  "t-please-upload-certificate-file": "请上传证书文件",
  "t-please-upload-apk": "请上传apk文件",
  "t-please-upload-dat-zip": "请上传dat或zip文件",
  "t-device-binding": "设备绑定",
  "t-device-unbinding": "设备解绑",
  "t-enter-version-name": "输入版本名",
  "t-version-name-required": "版本名是必填项",
  "t-select-year": "选择年份",
  "t-year-required": "年份是必填项",
  "t-enter-valid-year": "请输入有效年份",
  "t-select-icon": "选择图标",
  "t-resolution-required": "分辨率是必填项",
  "t-model-required": "型号是必填项",
  "t-search-model-version": "型号版本",
  "t-delete-model-version-confirmation": "删除型号版本确认",
  "t-delete-model-version": "确定要删除型号版本-{param}吗？",
  "t-error-deleting-model-version": "删除型号版本时发生错误",
  "t-select-valid-model": "请选择有效的型号",
  "t-confirm-delete-operation": "确认删除操作",
  "t-warning-to-delete": "确定要删除-{param}吗？",
  "t-manufacturer-deleted": "厂商{param}删除成功！",
  "t-model-version-deleted": "型号版本{param}删除成功！",
  "t-mfa-configuration": "合作伙伴设置",
  "t-error-fill-mandatory-fields": "请填写所有必填字段",
  "t-processing": "处理中",
  "t-reset-email-sent": "重置密码的电子邮件已发送",
  "t-delete-model-confirmation": "删除型号确认",
  "t-delete-confirmation-model": "确定要删除型号-{param}吗？",
  "t-device-deleted-successfully": "设备{param}删除成功！",
  "t-error-deleted-device": "删除设备时发生错误",
  "t-error-loading-devices": "加载设备时发生错误",
  "t-no-response-from-device": "设备无响应",
  "t-installed-applications": "已安装的应用程序",
  "t-add-application": "添加应用程序",
  "t-edit-application": "编辑应用程序",
  "t-add-application-version": "添加应用程序版本",
  "t-edit-application-version": "编辑应用程序版本",
  "t-application-version-saved-successfully": "应用程序版本{param}保存成功！",
  "t-application-version-updated-successfully": "应用程序版本{param}更新成功！",
  "t-search-application-version": "应用程序版本",
  "t-application-device-name": "应用程序名称",
  "t-version-name": "版本名称",
  "t-select-valid-application": "请选择有效的应用程序",
  "t-delete-application-version-confirmation": "删除应用程序版本确认",
  "t-warning-delete-application-version": "确定要删除应用程序版本-{param}吗？",
  "t-application-version-deleted": "应用程序版本{param}删除成功！",
  "t-error-deleting-application-version": "删除应用程序版本时发生错误",
  "t-error-application-name-required": "应用程序名称是必填项",
  "t-error-application-pattern": "应用程序名称由字母、数字、下划线、点和空格组成，不能以空格开头或结尾",
  "t-placeholder-enter-application-name": "输入应用程序名称",
  "t-placeholder-enter-application-description": "输入应用程序描述",
  "t-error-loading-application": "加载应用程序时发生错误",
  "t-application-created-successfully": "应用{param}创建成功！",
  "t-error-created-application": "创建应用程序时发生错误",
  "t-application-updated-successfully": "应用程序{param}更新成功！",
  "t-error-updated-application": "更新应用程序时发生错误",
  "t-application-version-file": "应用程序版本文件",
  "t-select-application-file": "选择应用程序文件",
  "t-placeholder-enter-application-version-name": "输入版本名",
  "t-error-application-version-required": "应用程序版本名称是必填项",
  "t-error-application-version-pattern": "应用程序版本名称由字母、数字、下划线、点和空格组成，不能以空格开头或结尾",
  "t-error-application-required": "应用程序是必填项",
  "t-error-loading-application-version": "加载应用程序版本时发生错误",
  "t-error-created-application-version": "创建应用程序版本时发生错误",
  "t-error-updated-application-version": "更新应用程序版本时发生错误",
  "t-select-certificate": "选择证书",
  "t-select-certificate-to-signed": "请选择要使用的证书",
  "t-application-deleted-successfully": "应用程序{param}删除成功！",
  "t-error-deleting-application": "删除应用程序时发生错误",
  "t-application-choose-type": "请选择要下载{param}的类型",
  "t-cannot-submit-repeatedly": "不能重复提交",
  "t-activate-kiosk": "激活霸屏",
  "t-deactivate-kiosk": "关闭霸屏",
  "t-activate-kiosk-mode": "开启霸屏模式",
  "t-deactivate-kiosk-mode": "关闭霸屏模式",
  "t-actions": "操作",
  "t-device-bulk-upload": "批量导入设备",
  "t-manufacturer-bulk-upload": "批量导入厂商",
  "t-partner-bulk-upload": "批量导入合作伙伴",
  "t-customer-bulk-upload": "批量导入客户",
  "t-merchant-bulk-upload": "批量导入商户",
  "t-store-bulk-upload": "批量导入商店",
  "t-cortex-scanner-bulk-upload": "批量导入Cortex Scanner",
  "t-import-devices": "导入设备",
  "t-from-date": "起始日期",
  "t-to-date": "结束日期",
  "t-error-from-date-required": "起始日期是必填项",
  "t-error-to-date-required": "结束日期是必填项",
  "t-state": "状态",
  "t-delete-device-confirmation": "删除设备确认",
  "t-warning-to-delete-device": "您确定要删除设备 - {param}吗？",
  "t-warning-to-recover-device": "您确定要解除设备拆机告警吗？",
  "t-confirm-to-lock-device": "您确定要解锁设备吗？",
  "t-delete-activated-device": "不能删除已激活的设备",
  "t-cannot-delete-device-has-tid": "不能删除带有TID的设备",
  "t-delete-device": "删除设备",
  "t-add-transaction-param": "添加交易参数",
  "t-add-transaction-param-version": "添加交易参数版本",
  "t-search-transaction-param": "交易参数",
  "t-search-transaction-param-version": "交易参数版本",
  "t-transaction-param-version": "交易参数版本",
  "t-total-version": "总版本",
  "t-add-partner": "添加合作伙伴",
  "t-search-push": "推送记录",
  "t-search-partner": "合作伙伴",
  "t-add-customer": "添加客户",
  "t-search-customer": "客户",
  "t-edit-transaction-param": "编辑交易参数",
  "t-error": "错误",
  "t-error-loading-template": "加载模板时发生错误",
  "t-error-creating-template": "创建模板时发生错误",
  "t-error-update-template": "更新模板时发生错误",
  "t-invalid-json": "JSON无效",
  "t-validate": "验证",
  "t-template-updated-successfully": "交易参数{param}更新成功！",
  "t-template-created-successfully": "交易参数{param}创建成功！",
  "t-enter-transaction-paramName": "输入交易参数名称",
  "t-required-transaction-name": "交易参数名称是必填项",
  "t-transaction-name-criteria": "交易参数名称只能包含字母、数字、下划线、点和空格，且不能以空格开头或结尾",
  "t-action-code": "操作代码",
  "t-required-transaction-action-code": "交易参数操作代码是必填项",
  "t-min-transaction-action-code": "交易参数操作代码必须大于200",
  "t-max-transaction-action-code": "交易参数操作代码必须小于299",
  "t-pattern-transaction-action-code": "交易参数操作代码只能是数字",
  "t-enter-action-code": "输入操作代码",
  "t-transaction-deleted-successfully": "交易参数{param}删除成功！",
  "t-error-deleting-transaction": "删除交易参数时发生错误",
  "t-error-deleting-transaction-child": "交易参数下存在交易参数版本，请先删除交易参数版本！",
  "t-edit-transaction-param-version": "编辑交易参数版本",
  "t-enter-transaction-param-version-name": "输入交易参数版本名称",
  "t-error-transaction-param-version-required": "交易参数版本是必填项",
  "t-enter-intent-name": "输入intent名称",
  "t-enter-file-name": "输入文件名",
  "t-error-loading-template-param-version": "加载交易参数版本时发生错误",
  "t-template-version-updated-successfully": "交易参数版本{param}更新成功！",
  "t-template-version-created-successfully": "交易参数版本{param}创建成功！",
  "t-error-creating-transaction-param-version": "创建交易参数版本时发生错误",
  "t-error-updating-transaction-param-version": "更新交易参数版本时发生错误",
  "t-groups": "组",
  "t-add-group": "添加组",
  "t-edit-group": "编辑组",
  "t-search-group-device": "搜索组内设备",
  "t-group-name-required": "组名是必填项",
  "t-group-name-pattern": "组名称只能包含字母、数字、下划线、点和空格，且不能以空格开头或结尾",
  "t-enter-group-name": "输入组名",
  "t-group-created-successfully": "组{param}创建成功！",
  "t-error-group-created": "创建组时发生错误",
  "t-group-updated-successfully": "组{param}更新成功！",
  "t-error-group-updated": "更新组时发生错误",
  "t-drag-device-to-group": "将设备从可用列表拖动到选定列表",
  "t-to": "到",
  "t-device-update": "设备更新",
  "t-updated-group-device-successfully": "更新组{param}成功！",
  "t-please-enter-name": "请输入名称",
  "t-minimum-radius": "最小半径应为50",
  "t-maximum-radius": "最大半径应为9999",
  "t-duration-in-hours": "持续时间（小时）",
  "t-please-enter-duration": "请输入持续时间",
  "t-minimum-duration": "最短持续时间应为0",
  "t-maximum-duration": "最长持续时间应为72",
  "t-please-enter-action": "请输入操作",
  "t-already-have-lock-action": "如果已经有锁定操作，则警告操作的持续时间应小于锁定持续时间，因为设备将在锁定操作后停止执行任何进一步的操作",
  "t-add-locak-action-info": "如果您添加锁定操作，持续时间应大于最新的持续时间，因为如果选择锁定操作，设备将在此操作后停止执行任何进一步的操作",
  "t-invalid-warning-message": "无效的警告消息",
  "t-invalid-action": "无效操作",
  "t-invalid-duration": "无效持续时长",
  "t-geo-fence-created-successfully": "地理围栏{param}创建成功",
  "t-error-geo-fence-created": "创建地理围栏时发生错误",
  "t-geo-fence-updated-successfully": "地理围栏{param}更新成功",
  "t-error-geo-fence-updated": "更新地理围栏时发生错误",
  "t-category-name": "类别名称",
  "t-model-version-name": "型号版本名称",
  "t-production-batch-name": "生产批次名称",
  "t-sales-batch-name": "销售批次名称",
  "t-select-valid-transaction-param": "请选择有效的交易参数",
  "t-delete-transaction-param-version-confirmation": "删除交易参数版本确认",
  "t-warning-delete-transaction-param-version": "您确定要删除交易参数版本 - {param} 吗？",
  "t-transaction-param-version-deleted-successfully": "交易参数版本{param}删除成功！",
  "t-error-deleting-transaction-param-version": "删除交易参数版本时发生错误",
  "t-please-check-values": "请输入两个值",
  "t-check-value": "检查值",
  "t-error-check-value": "检查值时发生错误",
  "t-error-combine-keys": "合并密钥时发生错误",
  "t-error-invalid-key-check": "KCV值不正确",
  "t-error-loading-checking-key": "加载检查密钥时发生错误",
  "t-form-invalid-fill-mandatory": "表单无效，请填写必填字段",
  "t-create-key": "创建密钥",
  "t-error-creating-key": "创建密钥时发生错误",
  "t-key-created-successfully": "密钥{param}创建成功！",
  "t-error-key-created": "创建密钥时发生错误",
  "t-add-key": "添加密钥",
  "t-edit-key": "编辑密钥",
  "t-error-loading-created": "加载密钥时发生错误",
  "t-error-loading-algorithms": "加载算法时发生错误",
  "t-error-loading-partner": "加载合作伙伴时发生错误",
  "t-error-loading-keys": "加载密钥时发生错误",
  "t-key-deleted-successfully": "密钥{param}删除成功！",
  "t-error-deleting-key": "删除密钥时发生错误",
  "t-key-name-criteria": "密钥名称只能包含字母、数字、下划线，不能以空格开头或结尾",
  "t-delete-key-confirmation": "删除密钥",
  "t-warning-delete-key": "您确定要删除密钥 - {param} 吗？",
  "t-zeros-not-allowed": "不允许零",
  "t-enter-key-name": "输入密钥名称",
  "t-required-key-name": "密钥名称是必填项",
  "t-enter-index": "输入索引",
  "t-required-index": "索引是必填项",
  "t-only-allowed-positive-integer-index": "只允许使用正整数",
  "t-index-max": "索引值不能超过255",
  "t-select-date": "选择日期",
  "t-select-customer": "选择客户",
  "t-select-merchant": "选择商户",
  "t-select-store": "选择商店",
  "t-enter-key-group": "输入密钥组",
  "t-required-key-group": "密钥组是必填项",
  "t-required-encrypted-key-under": "加密密钥是必填项",
  "t-enter-key-value": "输入密钥值",
  "t-required-key-value-1": "密钥值1是必填项",
  "t-key-kcv": "KCV",
  "t-key-bdk-lmk": "BDK / LMK",
  "t-key-zmk-lmk": "ZMK / LMK",
  "t-key-lmk": "LMK密钥",
  "t-required-key-kcv-1": "KCV1是必填项",
  "t-expiry-date-greater-than-current-date": "过期日期应大于当前日期",
  "t-error-loading-key": "加载密钥时发生错误",
  "t-partners": "合作伙伴",
  "t-keys": "密钥",
  "t-key-name": "密钥名称",
  "t-is-required": "必填项",
  "t-enter-kcv": "输入KCV",
  "t-final-key": "最终密钥",
  "t-full-apk": "整包",
  "t-patch-file": "差分包",
  "t-application-certificate-message": "根据客户的批准证书显示设备列表",
  "t-error-patch-file-fail": "生成APK差分包失败",
  "t-create-patch-file-success": "APK差分包生成成功，开始推送，请转到推送报告以获取详细状态",
  "t-create-patch-file": "开始生成差分包",
  "t-required-type": "类型是必填项",
  "t-required-version": "版本号是必填项",
  "t-list-group": "组列表",
  "t-list-device": "设备列表",
  "t-list": "列表",
  "t-search-by-serial-number": "按序列号搜索设备",
  "t-sort": "排序",
  "t-sort-asc": "正序",
  "t-sort-desc": "倒序",
  "t-sort-devices": "排序设备",
  "t-uploading": "上传中",
  "t-please-select-group-devices": "请选择组或设备",
  "t-error-push-group-empty": "所选组内不包含设备！",
  "t-error-push-group-empty-by-model-version": "所选组不包含型号版本为{param}的设备！",
  "t-error-push-group-store-empty": "所选组中的设备没有绑定的商店！",
  "t-error-key-formation": "密钥格式错误",
  "t-key-generation": "生成密钥",
  "t-error-push-operation": "某些设备在推送操作中可能出现问题",
  "t-error-push-device-inactive": "推送失败，所选设备中存在未激活的设备",
  "t-error-push-device-abnormal": "推送失败, 所选设备中存在异常状态设备",
  "t-push-completed-successfully": "推送{param}成功",
  "t-push-batch-completed-successfully": "消息{param}推送成功，请前往推送记录中获取更多详细信息",
  "t-push-device-certificate-unpush": "{param}已移出合作伙伴，将不再推送",
  "t-went-wrong": "出现错误",
  "t-add-folder": "添加文件夹",
  "t-edit-folder": "编辑文件夹",
  "t-required-file-name": "文件名是必填项",
  "t-file-name-pattern": "文件名只支持字母、数字、下划线和横线",
  "t-select-file-type": "选择文件类型",
  "t-select-file": "选择文件",
  "t-maximum-folder-file-size": "文件大小应不超过 100 MB",
  "t-error-loading-folder": "加载文件夹时发生错误",
  "t-error-creating-folder": "创建文件夹时发生错误",
  "t-error-updating-folder": "更新文件夹时发生错误",
  "t-folder-created-successfully": "文件夹{param}创建成功！",
  "t-folder-updated-successfully": "文件夹{param}更新成功！",
  "t-folder-deleted-successfully": "文件夹{param}删除成功！",
  "t-required-folder-name": "文件夹名是必填项",
  "t-folder-name-pattern": "文件夹名称只支持字母、数字、下划线和横线",
  "t-select-partner": "选择合作伙伴",
  "t-warning-delete-folder": "您确定要删除{param}吗？",
  "t-enter-folder-name": "输入文件夹名称",
  "t-error-deleting-file": "删除文件时发生错误",
  "t-file-deleted-successfully": "文件{param}删除成功！",
  "t-select-folder": "请选择有效的文件夹",
  "t-error-select-file": "请选择符合{param}格式之一的图像",
  "t-error-select-file-video": "请选择符合{param}格式之一的视频",
  "t-file-created-successfully": "文件{param}创建成功",
  "t-create-file": "添加文件",
  "t-create-folder": "添加文件夹",
  "t-file-creation-failed": "文件创建失败",
  "t-file-updated-successfully": "文件更新成功",
  "t-file-updated-failed": "更新文件时发生错误",
  "t-warning-delete-file": "您确定要删除文件 - {param}吗？",
  "t-add-file": "添加文件",
  "t-edit-file": "编辑文件",
  "t-search-file": "文件",
  "t-search-advertisement": "广告",
  "t-preview": "预览",
  "t-file-uploaded-failed": "文件上传失败",
  "t-file-uploaded-successfully": "文件上传成功",
  "t-select-role": "选择角色",
  "t-add-role": "添加角色",
  "t-edit-role": "编辑角色",
  "t-delete-role": "删除角色",
  "t-delete-role-successfully": "角色-{param} 删除成功!",
  "t-widget-settings": "插件设置",
  "t-enter-role-name": "输入角色名称",
  "t-required-role-name": "角色名是必填项",
  "t-role-name-criteria": "角色名称只能包含字母、数字、下划线、点和空格，不能以空格开头或结尾",
  "t-role-created-successfully": "角色{param}创建成功！",
  "t-error-creating-role": "创建角色时发生错误",
  "t-role-updated-successfully": "角色{param}更新成功！",
  "t-error-updating-role": "更新角色时发生错误",
  "t-permissions-updated-successfully": "权限更新成功",
  "t-permissions-error-updated": "更新权限时发生错误",
  "t-permissions-updated-error": "更新权限时发生错误",
  "t-permission": "权限",
  "t-browser-local-time": "浏览器本地时间",
  "t-panel-name": "面板名称",
  "t-add-system-param": "添加系统参数",
  "t-edit-system-param": "编辑系统参数",
  "t-search-system-param": "搜索系统参数",
  "t-enter-system-param-name": "输入系统参数名称",
  "t-required-system-param": "系统参数名称是必填项",
  "t-error-loading-system-param": "加载系统参数时发生错误",
  "t-system-param-created-successfully": "系统参数{param}创建成功！",
  "t-error-creating-system-param": "创建系统参数时发生错误",
  "t-system-param-updated-successfully": "系统参数{param}更新成功！",
  "t-error-updating-system-param": "更新系统参数时发生错误",
  "t-system-param-deleted-successfully": "系统参数{param}删除成功！",
  "t-error-deleting-system-param": "删除系统参数时发生错误",
  "t-enter-system-param-version-name": "输入系统参数版本名称",
  "t-required-system-param-verion": "系统参数版本是必填项",
  "t-system-param-name-criteria": "系统参数版本名称只能包含字母、数字、下划线、点和空格，且不能以空格开头或结尾",
  "t-add-system-param-version": "添加系统参数版本",
  "t-edit-system-param-version": "编辑系统参数版本",
  "t-error-loading-system-param-version": "加载系统参数版本时出错",
  "t-system-param-version-created-successfully": "系统参数版本{param}创建成功！",
  "t-error-creating-system-param-version": "创建系统参数版本时发生错误",
  "t-search-system-param-version": "搜索系统参数版本",
  "t-select-valid-system-param-version": "请选择一个有效的系统参数",
  "t-delete-system-param-version-confirmation": "删除系统参数版本确认",
  "t-warning-delete-system-param-version": "您确定要删除系统参数版本 - {param} 吗？",
  "t-system-param-version-deleted-successfully": "系统参数版本{param}删除成功！",
  "t-error-deleting-system-param-version": "删除系统参数版本时发生错误",
  "t-add-ui-settings": "添加UI设置",
  "t-edit-ui-settings": "编辑UI设置",
  "t-error-loading-ui-settings": "加载UI设置时发生错误",
  "t-error-creating-ui-settings": "创建UI设置时发生错误",
  "t-error-updating-ui-settings": "更新UI设置时发生错误",
  "t-ui-settings-created": "UI设置{param}创建成功！",
  "t-ui-settings-updated": "UI设置{param}更新成功！",
  "t-enter-ui-settings-name": "输入UI设置名称",
  "t-required-ui-settings": "UI设置名称是必填项",
  "t-error-description-pattern": "描述只能包含字母、数字、下划线、点和空格，且不能以空格开头或结尾",
  "t-enter-ui-settings-description": "输入UI设置描述",
  "t-required-ui-settings-action": "UI设置操作是必填项",
  "t-file-type": "文件类型",
  "t-search-ui-settings": "搜索UI设置",
  "t-error-deleting-ui-settings": "删除UI设置时发生错误",
  "t-ui-settings-deleted-successfully": "UI设置{param}删除成功！",
  "t-no-preview-available-zip": "ZIP文件无法预览",
  "t-no-preview-available-file": "不支持此文件格式预览",
  "t-no-preview-available-video": "视频文件无法预览",
  "t-browser-not-support-video-tags": "您的浏览器不支持视频标签",
  "t-preview-ui-settings": "预览UI设置",
  "t-download-failed": "下载失败",
  "t-add-ui-settings-version": "添加UI设置版本",
  "t-pushable": "可推送",
  "t-ui-settings-version": "UI设置版本",
  "t-please-select-valid-setting": "请选择一个有效的设置",
  "t-warning-delete-ui-setting-version": "您确定要删除UI设置版本 - {param} 吗？",
  "t-confirmation-delete-ui-settings-version": "删除UI设置版本确认",
  "t-ui-settings-version-deleted-successfully": "UI设置版本{param}删除成功！",
  "t-error-deleting-ui-settings-version": "删除UI设置版本时发生错误",
  "t-enter-description": "输入描述",
  "t-required-ui-setting": "UI设置是必填项",
  "t-ui-setting-version-file": "UI设置版本文件",
  "t-select-setting-file": "选择设置文件",
  "t-ui-setting-version": "UI设置版本",
  "t-add-ui-setting-version": "添加UI设置版本",
  "t-edit-ui-setting-version": "编辑UI设置版本",
  "t-file-resolution-does-not-match": "文件分辨率与型号分辨率不匹配",
  "t-file-type-does-not-match": "请上传正确的文件",
  "t-file-read-failed": "文件读取失败，请重新上传",
  "t-ui-setting-version-file-type": "请上传{param}文件",
  "t-error-loading-setting-version": "加载UI设置版本时发生错误",
  "t-ui-setting-version-saved-successfully": "UI设置版本{param}保存成功！",
  "t-ui-setting-version-updated-successfully": "UI设置版本{param}更新成功！",
  "t-error-creating-ui-settings-version": "创建UI设置版本时发生错误",
  "t-error-updating-ui-settings-version": "更新UI设置版本时发生错误",
  "t-delete-brand": "删除HSM设置",
  "t-brand": "HSM设置",
  "t-search-brand": "搜索HSM设置",
  "t-add-brand": "添加HSM设置",
  "t-edit-brand": "编辑HSM设置",
  "t-warning-delete-model": "您确定要删除型号 - {param} 吗？",
  "t-error-loading-brands": "加载HSM设置时发生错误",
  "t-brand-created-successfully": "HSM {param}创建成功！",
  "t-error-creating-brand": "创建HSM设置时发生错误",
  "t-brand-updated-successfully": "HSM {param}更新成功！",
  "t-error-updating-brand": "更新HSM设置时发生错误",
  "t-brand-deleted-successfully": "HSM {param}成功删除！",
  "t-error-deleting-brand": "删除HSM设置时发生错误",
  "t-enter-brand-name": "输入HSM设置名称",
  "t-required-brand-name": "HSM设置名称是必填项",
  "t-edit-model": "编辑型号",
  "t-error-updating-model": "更新型号时发生错误",
  "t-spec-url": "规范Url",
  "t-enter-spec-url": "输入规范Url",
  "t-required-spec-url": "请输入有效的规范Url",
  "t-hsm-brand": "Hsm Brand",
  "t-add-interface": "添加接口",
  "t-edit-interface": "编辑接口",
  "t-error-loading-interfaces": "加载接口时发生错误",
  "t-interface-created-successfully": "接口{param}创建成功！",
  "t-error-creating-interface": "创建接口时发生错误",
  "t-interface-updated-successfully": "接口{param}更新成功！",
  "t-error-updating-interface": "更新接口时发生错误",
  "t-search-interface": "搜索接口",
  "t-enter-interface-name": "输入接口名称",
  "t-required-interface-name": "接口名称是必填项",
  "t-enter-user-name": "输入用户名",
  "t-required-user-name": "请输入有效的用户名",
  "t-required-password": "请输入有效的密码",
  "t-enter-primary-host": "输入主机地址",
  "t-required-primary-host": "请输入有效的主机地址",
  "t-enter-primary-port": "输入主机端口",
  "t-required-primary-port": "请输入有效的主机端口号",
  "t-enter-secondary-host": "输入辅助主机地址",
  "t-required-secondary-host": "请输入有效的辅助主机地址",
  "t-enter-secondary-port": "输入辅助端口",
  "t-required-secondary-port": "请输入有效的辅助主机端口号",
  "t-is-enable": "是否启用",
  "t-select-valid-interface": "请选择一个有效的接口",
  "t-delete-interface-confirmation": "删除接口确认",
  "t-warning-delete-interface": "您确定要删除接口 - {param} 吗？",
  "t-delete-interface": "删除接口",
  "t-interface-deleted-successfully": "接口{param}删除成功！",
  "t-error-deleting-interface": "删除接口时发生错误",
  "t-partner-name": "合作伙伴名称",
  "t-enable-2FA": "启用OTP",
  "t-enable-signature": "启用签名",
  "t-enable-remote-control": "远程控制",
  "t-partner-setting": "合作伙伴设置",
  "t-search-user": "用户",
  "t-add-user": "添加用户",
  "t-edit-user": "编辑用户",
  "t-error-creating-user": "创建用户时发生错误",
  "t-user-created-successfully": "用户{param}创建成功！",
  "t-error-updating-user": "更新用户时发生错误",
  "t-required-email": "邮箱是必填项",
  "t-enter-correct-email": "请输入正确的邮箱格式",
  "t-enter-email": "输入邮箱",
  "t-enter-first-name": "输入名字",
  "t-required-first-name": "名字是必填项",
  "t-enter-last-name": "输入姓氏",
  "t-current-password": "当前密码",
  "t-new-password": "新密码",
  "t-please-fill-all-mandatory-fields": "请填写所有必填项字段",
  "t-user-password-changed-successfully": "用户密码更改成功，请重新登录！",
  "t-error-changing-user-password": "当前密码错误或更改用户密码时发生错误",
  "t-user-profile": "用户资料",
  "t-user-avatar-modified-successfully": "用户头像修改成功！",
  "t-user-avatar-modified-failed": "用户头像修改失败！",
  "t-user-avatar-deletion-successfully": "用户头像删除成功！",
  "t-user-avatar-deletion-failed": "用户头像删除失败！",
  "t-user-avatar-not-exist": "用户头像不存在!",
  "t-user-avatar-select-failed": "请选择用户头像！",
  "t-roles": "角色",
  "t-error-length-password": "密码长度至少为 ",
  "t-error-minimum-length-password": "密码长度至少为6位",
  "t-error-maximum-length-password": "密码长度不能超过32位",
  "t-error-password-criteria": "密码格式应为数字和字母的组合",
  "t-enter-confirm-password": "输入确认密码",
  "t-warning-reset-password": "您确定要重置密码吗？",
  "t-sent-reset-password": "重置密码邮件发送成功。",
  "t-resend-token-email": "发送激活二维码",
  "t-resend-email-successfully": "用户发送电子邮件成功！",
  "t-error-resend-email": "用户发送电子邮件失败！",
  "t-delete-user": "删除用户",
  "t-cannot-delete-activated-user": "无法删除已启用的用户",
  "t-user-deactivated-successfully": "用户已禁用",
  "t-user-permission-update-successfully": "用户权限更新成功",
  "t-user-activated-successfully": "用户启用成功",
  "t-reset-password-sent-successfully": "重置密码的电子邮件发送成功",
  "t-user-activated-token-successfully": "用户激活手机令牌成功！",
  "t-user-updated-successfully": "用户{param}更新成功！",
  "t-warning-delete-user": "您确定要删除用户 - {param1} {param2}吗？",
  "t-delete-user-confirmation": "删除用户确认",
  "t-token-replaced-successfully": "用户更换手机令牌成功！",
  "t-error-token-replace": "用户更换手机令牌失败！",
  "t-error-token-activation": "用户激活手机令牌失败！",
  "t-group-deleted-successfully": "删除组{param}成功！",
  "t-error-deleting-group": "删除组时发生错误",
  "t-delete-partner": "删除合作伙伴",
  "t-partner-deleted-successfully": "合作伙伴{param}删除成功！",
  "t-error-deleted-partner": "删除合作伙伴时发生错误",
  "t-edit-partner": "编辑合作伙伴",
  "t-error-loading-partners": "加载合作伙伴时发生错误",
  "t-partner-created-successfully": "合作伙伴{param}创建成功！",
  "t-error-created-partner": "创建合作伙伴时发生错误",
  "t-partner-updated-successfully": "合作伙伴{param}更新成功！",
  "t-error-updated-partner": "更新的合作伙伴时发生错误",
  "t-required-continent-name": "大陆名称是必填项",
  "t-required-region-name": "地区名称是必填项",
  "t-required-country-name": "国家名称是必填项",
  "t-select-continent": "选择大陆",
  "t-select-region": "选择地区",
  "t-error-loading-countries": "加载国家时发生错误",
  "t-enter-partner-name": "输入合作伙伴名称",
  "t-required-partner-name": "合作伙伴名称是是必填项",
  "t-partner-name-criteria": "合作伙伴名称只能包含字母、数字、下划线、点和空格，不能以空格开头或结尾",
  "t-enter-phone-no": "输入电话号码",
  "t-required-valid-phone-no": "输入有效的电话号码",
  "t-enter-email-address": "输入邮箱地址",
  "t-required-valid-email-address": "请输入有效的邮箱地址",
  "t-enter-address": "输入地址",
  "t-error-enter-valid-address": "地址只允许输入大写和小写字母、数字和横杠",
  "t-required-parent-partner": "请输入父合作伙伴",
  "t-edit-customer": "编辑客户",
  "t-enter-customer-name": "输入客户名称",
  "t-required-customer-name": "客户名称是必填项",
  "t-required-customer": "客户是必填项",
  "t-customer-name-criteria": "客户名称只能包含字母、数字、下划线、点和空格，不能以空格开头或结尾",
  "t-error-loading-customers": "加载客户时发生错误",
  "t-customer-created-successfully": "客户{param}创建成功！",
  "t-error-created-customer": "创建客户时发生错误",
  "t-customer-updated-successfully": "客户{param}更新成功！",
  "t-error-updated-customer": "更新客户时发生错误",
  "t-warning-delete-customer": "您确定要删除客户- {param}吗？",
  "t-warning-delete-merchant": "您确定要删除商户- {param}吗？",
  "t-warning-delete-store": "您确定要删除商店- {param}吗？",
  "t-delete-customer": "删除客户",
  "t-customer-deleted-successfully": "客户{param}删除成功！",
  "t-error-deleted-customer": "删除客户时发生错误",
  "t-add-merchant": "添加商户",
  "t-edit-merchant": "编辑商户",
  "t-enter-mid": "输入MID",
  "t-error-loading-merchant": "加载商户时发生错误",
  "t-merchant-created-successfully": "商户{param}创建成功！",
  "t-error-created-merchant": "创建商户时发生错误",
  "t-merchant-updated-successfully": "商户{param}更新成功！",
  "t-error-updated-merchant": "更新商户时发生错误",
  "t-enter-merchant-name": "输入商户名称",
  "t-required-merchant-name": "商户名称是必填项",
  "t-required-merchant": "商户是必填项",
  "t-merchant-name-criteria": "商户名称只能包含字母、数字、下划线、点和空格，不能以空格开头或结尾",
  "t-merchant-deleted-successfully": "商户{param}删除成功！",
  "t-error-deleted-merchant": "删除商户时发生错误",
  "t-delete-merchant": "删除商户",
  "t-search-merchant": "商户",
  "t-merchant-name": "商户名称",
  "t-error-loading-store": "加载商店时发生错误",
  "t-store-created-successfully": "商店{param}创建成功！",
  "t-error-created-store": "创建商店时发生错误",
  "t-store-updated-successfully": "商店{param}更新成功！",
  "t-error-updated-store": "更新商店时发生错误",
  "t-enter-store-name": "输入商店名称",
  "t-required-valid-customer": "请选择有效的客户",
  "t-required-valid-merchant": "请选择有效的商户",
  "t-required-store-name": "商店名称是必填项",
  "t-store-name-criteria": "商店名称只能包含字母、数字、下划线、点和空格，不能以空格开头或结尾",
  "t-search-store": "商店",
  "t-add-store": "添加商店",
  "t-edit-store": "编辑商店",
  "t-required-valid-store": "请选择有效的商店",
  "t-delete-store": "删除商店",
  "t-store-deleted-successfully": "商店{param}删除成功！",
  "t-deleting-store": "删除商店",
  "t-error-store-deleted": "删除商店时发生错误",
  "t-manufacturer-created-successfully": "厂商{param}创建成功！",
  "t-error-manufacturer-created": "创建厂商时发生错误",
  "t-manufacturer-updated-successfully": "厂商{param}更新成功！",
  "t-error-manufacturer-updated": "更新厂商时发生错误",
  "t-manufacturer-deleted-successfully": "厂商{param}删除成功！",
  "t-error-manufacturer-deleted": "删除厂商时发生错误",
  "t-error-model-pattern": "型号名称应由字母、数字、下划线、点和空格组成，不能以空格开头或结尾",
  "t-error-model-version-pattern": "型号版本名称应由字母、数字、下划线、点和空格组成，不能以空格开头或结尾",
  "t-error-format-required": "格式是必填项",
  "t-model-version-created-successfully": "型号版本{param}创建成功！",
  "t-model-version-updated-successfully": "型号版本{param}更新成功！",
  "t-error-creating-model-version": "创建型号版本时发生错误",
  "t-error-updated-model-version": "更新型号版本时发生错误",
  "t-error-deleted-model": "删除型号时发生错误",
  "t-error-deleted-model-version": "删除型号版本时发生错误",
  "t-error-deleting-transaction-param": "删除交易参数时发生错误",
  "t-transaction-param-deleted-successfully": "交易参数{param}删除成功！",
  "t-required-valid-group": "请选择一个有效的组",
  "t-firmware-deleted-successfully": "固件{param}删除成功！",
  "t-error-deleting-firmware": "删除固件时发生错误",
  "t-required-valid-firmware": "请选择有效的固件",
  "t-firmware-version-deleted-successfully": "固件版本{param}删除成功！",
  "t-error-deleting-firmwareversion": "删除固件时发生错误",
  "t-download-firmware": "下载固件",
  "t-add-firmware-version": "添加固件版本",
  "t-edit-firmware-version": "编辑固件版本",
  "t-firmware-name": "固件名称",
  "t-search-firmware": "固件",
  "t-add-firmware": "添加固件",
  "t-edit-firmware": "编辑固件",
  "t-enter-firmware-name": "输入固件名称",
  "t-required-firmware-name": "固件名称是必填项",
  "t-firmware-name-criteria": "固件名称应由字母、数字、下划线、点和空格组成，不能以空格开头或结尾",
  "t-error-loading-firmware": "加载固件时发生错误",
  "t-firmware-created-successfully": "固件{param}创建成功！",
  "t-error-creating-firmware": "创建固件时发生错误",
  "t-firmware-updated-successfully": "固件{param}更新成功！",
  "t-error-updating-firmware": "更新固件时发生错误",
  "t-firmware-file": "固件文件",
  "t-select-firmware-file": "选择固件文件",
  "t-firmware-version-name": "固件版本名称",
  "t-required-version-name": "版本名称是必填项",
  "t-required-firmware": "固件是必填项",
  "t-error-firmware-version-pattern": "固件版本名称应由字母、数字、下划线、点、横线和空格组成，不能以空格开头或结尾",
  "t-error-loading-firmware-version": "加载固件版本时发生错误",
  "t-firmware-version-created-successfully": "固件版本{param}创建成功！",
  "t-error-creating-firmware-version": "创建固件版本时发生错误",
  "t-firmware-version-updated-successfully": "固件版本{param}更新成功！",
  "t-error-updating-firmware-version": "更新固件版本时发生错误",
  "t-manufacturer-consists": "厂商名称应由字母、数字、下划线、点和空格组成，不能以空格开头或结尾",
  "t-ui-settings-consists": "UI设置名称应由字母、数字、下划线、点和空格组成，不能以空格开头或结尾",
  "t-log-capture-title-types": "日志类型",
  "t-log-capture-title-logs": "日志",
  "t-log-capture-title-main": "主要日志",
  "t-log-capture-title-kernel": "内核日志",
  "t-btn-stop": "停止",
  "t-btn-capture": "抓取",
  "t-log-type": "日志类型",
  "t-log-type-main": "主要日志",
  "t-log-type-kernel": "内核日志",
  "t-create-log-capture-event": "抓取日志任务创建成功！",
  "t-search-logs": "日志",
  "t-error-creating-log-capture": "抓取日志时发生错误",
  "t-log-capture-process": "正在抓取日志",
  "t-stop-log-capture-event": "停止抓取日志！",
  "t-error-stop-log-capture-event": "停止抓取日志时发生错误！",
  "t-stop-log-capture-info": "抓取日志任务完成！",
  "t-error-enter-log-capture": "请检查设备序列号或日志类型是否已填写！",
  "t-time-limit": "时间限制",
  "t-download-log": "下载日志",
  "t-file-download-failed": "文件下载失败！",
  "t-error-log-forbidden": "抓取日志尚未完成，请稍候！",
  "t-error-deleting-log-file": "删除日志文件时发生错误！",
  "t-error-show-detail-log": "查看详细信息时发生错误！",
  "t-delete-log-file": "日志文件{param}成功删除！",
  "t-detail-log-title": "日志文件：{param} {date}",
  "t-add-log-capture-event": "添加日志抓取事件",
  "t-ap": "AP",
  "t-sp": "SP",
  "t-apFirmware": "AP",
  "t-spFirmware": "SP",
  "t-general-all": "全部",
  "t-to-include": "包括",
  "t-otp-password": "OTP密码",
  "t-select-entity": "选择实体",
  "t-other-settings": "其他设置",
  "t-metadata": "元数据",
  "t-available-servers": "可用服务器",
  "t-service": "服务",
  "t-url": "URL",
  "t-download-progress": "下载进行中",
  "t-send": "发送",
  "t-enter-email-instructions-to-tou": "输入您的电子邮件，说明将发送给您!",
  "t-search-message": "消息",
  "t-enter-message": "输入消息",
  "t-send-message": "发送消息",
  "t-message-mgmt": "消息管理",
  "t-required-duration": "持续时间是必填项",
  "t-required-message": "消息是必填项",
  "t-message-sent": "消息发送成功",
  "t-ad-planner": "广告计划",
  "t-add-ad-planner": "添加广告计划",
  "t-search-ad-planner": "广告计划",
  "t-enter-planner-name": "输入广告计划名称",
  "t-required-planner-name": "广告计划名称是必填项",
  "t-add-advertisement": "添加广告",
  "t-edit-advertisement": "编辑广告",
  "t-error-end-time-greater-than-start": "结束时间应大于开始时间",
  "t-advertisement-updated-successfully": "广告{param}更新成功！",
  "t-error-updating-advertisement": "更新广告时发生错误",
  "t-advertisement-created-successfully": "广告{param}创建成功！",
  "t-error-creating-advertisement": "创建广告时发生错误",
  "t-error-loading-advertisement": "加载广告时发生错误",
  "t-add-planner": "添加广告计划",
  "t-edit-planner": "编辑广告计划",
  "t-select-planner": "请选择一个有效的广告计划",
  "t-error-loading-planner": "加载广告计划时发生错误",
  "t-planner-created-successfully": "广告计划{param}创建成功！",
  "t-error-created-planner": "创建广告计划时发生错误",
  "t-planner-updated-successfully": "广告计划{param}更新成功！",
  "t-error-updated-planner": "更新广告计划时发生错误",
  "t-delete-advertisement": "删除广告",
  "t-advertisement-deleted-successfully": "广告{param}删除成功！",
  "t-error-deleting-advertisement": "删除广告时发生错误",
  "t-advertisement-expired": "广告已过期",
  "t-advertisement-end-time": "结束时间应大于当前时间",
  "t-planner-deleted-successfully": "广告计划{param}删除成功！",
  "t-error-deleting-planner": "删除广告计划时发生错误",
  "t-warning-delete-advertisement": "您确定要删除广告 - {param} 吗？",
  "t-warning-delete-planner": "您确定要删除广告计划 - {param} 吗？",
  "t-select-ads-start-date": "选择广告开始日期",
  "t-select-ads-end-date": "选择广告结束日期",
  "t-ads-name": "广告名称",
  "t-ads-name-required": "广告名称是必填项",
  "t-enter-ad-name": "输入广告名称",
  "t-ads-start-required": "广告开始日期是必填项",
  "t-ads-end-required": "广告结束日期是必填项",
  "t-enter-detail-url": "输入详情URL",
  "t-detail-url-required": "详情URL是必填项",
  "t-start-date": "开始日期",
  "t-end-date": "结束日期",
  "t-message-name-required": "消息名称是必填项",
  "t-required-message-type": "消息类型是必填项",
  "t-message-content-required": "消息内容是必填项",
  "t-placeholder-message-text": "在此处编写文本消息",
  "t-select-execute-date": "选择执行日期",
  "t-select-expired-date": "选择过期日期",
  "t-select-executed-date": "选择执行日期",
  "t-expiration-time-greater-than-execution-time": "过期时间应大于执行时间",
  "t-execution-time-less-than-current-time": "执行时间应大于当前时间",
  "t-expiration-time-less-than-current-time": "过期时间应大于当前时间",
  "t-message-created-successfully": "消息{param}创建成功！",
  "t-error-creating-message": "创建消息时发生错误",
  "t-message-updated-successfully": "消息{param}更新成功！",
  "t-error-updated-message": "更新消息时发生错误",
  "t-folders": "文件夹",
  "t-available-files": "可用文件",
  "t-selected-files": "已选择的文件",
  "t-start-remote-control": "启动远程控制",
  "t-stop-remote-control": "停止远程控制",
  "t-account-not-exist": "登录账户不存在，请仔细检查",
  "t-search-Keys": "搜索",
  "t-details": "详细信息",
  "t-transaction-id": "事务处理ID",
  "t-payment-certificates": "TLS证书",
  "t-payment-application-certificates": "TLS证书",
  "t-add-payment-application-certificate": "添加TLS证书",
  "t-search-certificate": "证书",
  "t-add-certificate": "添加证书",
  "t-edit-certificate": "编辑证书",
  "t-enter-name": "输入名称",
  "t-set-password": "设置密码",
  "t-enter-password": "输入密码",
  "t-enter-new-password": "输入新密码",
  "t-confirm-new-password": "确认新密码",
  "t-private-key-password": "私钥密码",
  "t-certificateLevel-1": "1级证书",
  "t-certificateLevel-2": "2级证书",
  "t-level1-certificates": "一级证书",
  "t-please-select-customer": "请选择客户",
  "t-please-select-certificate": "请选择证书",
  "t-please-select-common-name": "请输入通用名称",
  "t-please-select-org-unit": "请输入组织单位",
  "t-please-select-org-name": "请输入组织名称",
  "t-please-select-city": "请输入城市",
  "t-please-select-state": "请输入州/省",
  "t-please-select-country": "请输入国家",
  "t-please-select-rsa-key": "请选择RSA密钥",
  "t-please-enter-password": "请输入密码",
  "t-prohibit-enter-space": "Prohibit entering spaces.",
  "t-error-maximum-length-key-password": "密码长度最多为10位",
  "t-error-confirm-password-equal-new-password": "确认密码必须与新密码相同",
  "t-signed-l2-certificate": "签名Level2证书",
  "t-cert-name": "证书名称",
  "t-enter-common-name": "输入通用名称",
  "t-enter-org-unit": "输入组织单位",
  "t-enter-org": "输入组织",
  "t-enter-city": "输入城市",
  "t-enter-state": "输入州/省",
  "t-enter-country": "输入国家",
  "t-certificate-updated-successfully": "证书{param}更新成功",
  "t-certificate-created-successfully": "证书{param}创建成功",
  "t-reover-tamper-status": "您确定解除设备拆机告警吗？",
  "t-recover-tamper-success": "解除设备拆机告警已成功发送到设备",
  "t-recover-tamper-error": "发送解除设备拆机告警请求失败",
  "t-recover-key-error": "发送设备初始化密钥请求失败",
  "t-add-message": "添加消息",
  "t-select-message": "请选择有效的合作伙伴",
  "t-enter-message-name": "输入消息名称",
  "t-warning-delete-messageList": "您确定要删除消息-{param}吗？",
  "t-messageList-deleted-successfully": "消息 {param} 删除成功！",
  "t-error-deleting-messagelist": "消息删除失败",
  "t-error-loading-message": "加载消息时发生错误",
  "t-create-message": "添加消息",
  "t-edit-message": "编辑消息",
  "t-key-bulk-upload": "密钥批量上传",
  "t-import-key": "导入密钥",
  "t-update-type": "更新类型",
  "t-full": "整包",
  "t-patch": "差分包",
  "t-warning-delete-certificate": "您确定要删除证书-{param}吗？",
  "t-cert-mgmt": "证书管理",
  "t-upload-certificate": "上传证书",
  "t-create-certificate": "创建证书",
  "t-error-deleting-certificate": "删除证书时发生错误",
  "t-certificate-deleted-successfully": "证书{param} 删除成功！",
  "t-upload-successfully": "上传文件成功！",
  "t-upload-failed": "上传文件失败！",
  "t-delete-sub-ca-confirm-tip": "删除该 Sub CA 后，同合作伙伴下的 Server Cert 和私钥将一并删除，涉及设备需重新绑定",
  "t-delete-server-cert-confirm-tip": "删除该 Server Cert 后，同合作伙伴下已绑定的设备需重新绑定",
  "t-certificateLevel": "证书级别",
  "t-signature-success": "证书生成成功",
  "t-error-creating-certificate": "创建证书时发生错误",
  "t-error-updating-certificate": "更新证书时发生错误",
  "t-import-customer": "导入客户",
  "t-import-manufacturer": "导入厂商",
  "t-import-partner": "导入合作伙伴",
  "t-import-merchant": "导入商户",
  "t-import-store": "导入商店",
  "t-search-folder": "文件夹",
  "t-timeline-device": "生命周期",
  "t-login-confirm-partner": "检测到合作伙伴登录，您要注销合作伙伴还是继续吗？",
  "t-created-date": "创建日期",
  "t-created-by": "创建者",
  "t-created-time": "创建时间",
  "t-partner-open-2nd-signature": "合作伙伴已开启二次签名",
  "t-signed-by-feitian": "由飞天证书签名",
  "t-add-profile": "添加终端初始化文件",
  "t-edit-profile": "编辑终端初始化文件",
  "t-delete-profile": "删除终端初始化文件",
  "t-profile-name": "终端初始化文件名称",
  "t-partnerName": "合作伙伴名称",
  "t-modelVersionName": "型号版本名称",
  "t-profile-name-required": "终端初始化文件名是必填项",
  "t-profile-created": "终端初始化文件{param} 创建成功！",
  "t-profile-updated": "终端初始化文件{param} 更新成功！",
  "t-error-creating-profile": "创建终端初始化文件时发生错误",
  "t-error-updating-profile": "更新终端初始化文件时发生错误",
  "t-enable-profile-success": "终端初始化文件开启成功",
  "t-enable-profile-close": "终端初始化文件关闭成功",
  "t-select-least-operation": "请至少选择一个操作",
  "t-select-identical-application": "您选择了重复的应用程序",
  "t-enable-profile-fail": "终端初始化文件启用失败",
  "t-delete-profile-error": "终端初始化文件已启用，无法删除！",
  "t-search-profile": "终端初始化文件",
  "t-warning-delete-profile": "您确定要删除终端初始化文件 - {param}吗？",
  "t-delete-profile-confirmation": "删除终端初始化文件确认",
  "t-profile-deleted": "终端初始化文件{param}删除成功！",
  "t-cancel-push": "撤销推送",
  "t-abort": "撤销",
  "t-warning-delete-geo-fence": "您确定要删除地理围栏 - {param}吗？",
  "t-geoFence-deleted-successfully": "地理围栏删除成功！",
  "t-error-deleting-geoFence-version": "删除地理围栏时发生错误",
  "t-add-geo-fencing": "添加地理围栏",
  "t-edit-geo-fencing": "编辑地理围栏",
  "t-search-geo-fencing": "地理围栏",
  "t-save": "保存",
  "t-delete-file": "删除文件",
  "t-warning-message": "警告信息",
  "t-warning-add-block-device": "如果选择锁定操作，设备将在此操作后不执行任何进一步操作",
  "t-confirm-block-device": "确认锁定设备",
  "t-proceed": "继续",
  "t-fix-report": "静态报表",
  "t-start-time": "开始时间",
  "t-end-time": "结束时间",
  "t-select-start-time": "选择开始日期",
  "t-select-end-time": "选择结束日期",
  "t-error-exporting-report": "导出报表失败",
  "t-report-mgmt": "报表管理",
  "t-select-all": "全选",
  "t-select-current-page": "选择当前页",
  "t-deselect-all": "取消全选",
  "t-transaction-version-information": "STORM已自动根据序列号在Json中集成了TID和MID，因此您无需在Json中设置TID和MID。如果您仍然设置TID和MID，我们将使用您的版本",
  "t-support-mgmt": "支持管理",

  "t-tickets-updated-successfully": "工单更新成功！",
  "t-error-push-ui-group-empty": "所选组中存在不同型号版本的设备！",
  "t-warning-to-delete-push-event": "您确定要删除推送事件吗？",
  "t-push-event-deleted-successfully": "推送事件删除成功！",
  "t-application-push-by-group-error": "{param}尚未绑定到客户级别，请先进行绑定！",
  "t-merchant-redirect-confirm": "您想重定向到商户门户吗？还是继续使用STORM？",
  "t-merchant-redirect-title": "重定向到商户门户",
  "t-merchant-redirect": "重定向",
  "t-abnormal-device": "异常设备",
  "t-log-download-failed": "日志获取失败，无法下载",
  "t-log-deleting-error": "当日志获取失败时，应该提示日志获取失败且无法删除",
  "t-account-exception": "您的帐户处于异常状态，请联系管理员！",
  "t-account-permission-exception": "用户权限已更新，请联系管理员！",
  "t-signed": "签名",
  "t-unsigned": "未签名",
  "t-select-valid-partner": "请选择有效的合作伙伴",
  "t-password-mismatch": "密码不匹配",
  "t-support-gms": "支持Gms",
  "t-search-repository": "存储库",
  "t-repository": "存储库",
  "t-add-repository": "添加存储库",
  "t-edit-repository": "编辑存储库",
  "t-error-loading-repository": "加载存储库时发生错误",
  "t-repository-updated-successfully": "存储库{param}更新成功！",
  "t-error-updating-repository": "更新存储库时发生错误",
  "t-repository-created-successfully": "存储库{param}创建成功！",
  "t-error-creating-repository": "创建存储库时发生错误",
  "t-error-deleting-repository": "删除存储库时发生错误",
  "t-repository-name-criteria": "存储库名称只能包含字母、数字、下划线、点和空格，不能以空格开头或结尾",
  "t-required-repository-name": "存储库名称是必填项",
  "t-enter-repository-name": "输入存储库名称",
  "t-add-cloud-message": "添加云消息",
  "t-required-valid-cloud-message": "请选择有效的云消息",
  "t-required-cloud-name": "名称是必填项",
  "t-token": "令牌",
  "t-repository-deleted-successfully": "存储库{param}删除成功！",
  "t-cloud-message-deleted-successfully": "云消息{param}删除成功！",
  "t-search-cloud-message": "云消息",
  "t-cloud-name-criteria": "云消息名称只能包含字母、数字、下划线、点和空格，不能以空格开头或结尾",
  "t-enter-token": "输入令牌",
  "t-edit-cloud-message": "编辑云消息",
  "t-error-loading-cloud-message": "加载云消息时发生错误",
  "t-cloud-message-updated-successfully": "云消息{param}更新成功！",
  "t-error-loading-updating-cloud-message": "更新云消息时发生错误",
  "t-cloud-message-created-successfully": "云消息{param}创建成功！",
  "t-error-loading-creating-cloud-message": "创建云消息时发生错误",
  "t-error-deleting-cloud-message": "删除云消息时发生错误",
  "t-push-setting": "推送设置",
  "t-error-deleting-folder": "删除文件夹时发生错误",
  "t-cortex-scanner-import": "Cortex Scanner导入",
  "t-import-cortex-scanner": "导入Cortex Scanner",
  "t-import-cortex-scanner-success": "文件导入成功！",
  "t-system-info": "系统信息",
  "t-payment-kernel": "支付内核",
  "t-device-configuration": "设备配置",
  "t-functional-info": "功能信息",

  "t-push-install-type": "安装类型",
  "t-automatic-upgrade": "自动升级",
  "t-push-transaction-detail": "推送",
  "t-push-is-mobile-traffic": "是否使用移动数据",
  "t-push-start-time": "开始时间",
  "t-push-end-time": "结束时间",
  "t-push-details": "推送详细信息",
  "t-activated-kiosk-mode": "激活霸屏模式",
  "t-unActivated-kiosk-mode": "解除霸屏模式",
  "t-push-abort-successfully": "撤销推送成功！",
  "t-error-push-abort": "撤销推送时发生错误",
  "t-push-event": "计划任务",
  "t-add-push-event": "添加计划任务",
  "t-edit-push-event": "编辑计划任务",
  "t-required-event-name": "计划任务名称是必填项",
  "t-event-name-pattern": "计划任务名称只能包含字母、数字、下划线、点和空格，不能以空格开头或结尾",
  "t-event-is-planned": "计划",
  "t-required-action": "操作是必填项",
  "t-search-group-by-name": "按名称搜索组",
  "t-search-device-by-sn": "按序列号搜索设备",
  "t-push-event-application-version": "应用程序和版本",
  "t-old": "旧",
  "t-is-planned": "计划",
  "t-inStalled-application": "已安装的应用程序",
  "t-push-event-firmware-version": "固件和版本",
  "t-new-version": "新版本",
  "t-old-version": "旧版本",
  "t-enable-disable": "启用/禁用",
  "t-ui-setting-list": "UI设置列表",
  "t-select-group-or-device": "请选择包含设备的组或设备",
  "t-select-application-to-install": "请选择要推送的应用程序版本",
  "t-select-fireware-to-install": "请选择要安装的固件版本",
  "t-select-application-to-uninstall": "请选择要卸载的应用程序",
  "t-select-ui-setting": "请选择UI设置",
  "t-push-event-created-successfully": "推送事件{param}创建成功",
  "t-error-created-push-event": "创建推送事件时发生错误",
  "t-execution-time-greater-than-current-time": "执行时间应大于当前时间",
  "t-push-event-updated-successfully": "推送事件{param}更新成功",
  "t-import-device-information-details": "导入设备信息详情",
  "t-import-customer-information-details": "导入客户信息详情",
  "t-import-partner-information-details": "导入合作伙伴信息详情",
  "t-import-manufacturer-information-details": "导入厂商信息详情",
  "t-import-merchant-information-details": "导入商户信息详情",
  "t-import-store-information-details": "导入商店信息详情",
  "t-import-key-information-details": "导入密钥信息详情",
  "t-import-cortex-scanner-information-details": "导入Cortex Scanner信息详情",
  "t-push-key-empty-error": "组下没有与该密钥匹配的设备",

  "t-total-number": "总数",
  "t-select-tid-to-use": "请选择要使用的TID",
  "t-import-failed": "导入失败",
  "t-network-gateway-timeout": "网络请求超时，请重试！",
  "t-network-service-unavailable": "维护中，请稍后重试！",
  "t-network-bad-gateway": "无效的请求，请重试！",
  "t-network-not-found": "资源不存在，请联系管理员！",
  "t-network-forbidden": "没有权限，无法访问！",
  "t-network-bad-request": "请求体错误，请重试！",
  "t-network-method-not-allowed": "方法不允许，请重试！",
  "t-spring-configuration": "Spring 配置",
  "t-prefix": "前缀",
  "t-properties": "属性",
  "t-done": "完成",
  "t-property": "属性",
  "t-git-branch": "git分支",
  "t-git-version": "git版本",
  "t-zone": "时区",
  "t-management-port": "管理端口",
  "t-git-commit": "git提交",
  "t-health-checks": "健康检查",
  "t-service-name": "服务名称",
  "t-otp-mobile-installation-manual": "手机令牌安装手册",
  "t-otp-mobile-installation-manual-android": "《手机令牌（Android）安装手册",
  "t-installation-manual-android-1": "1-进入 Google 市场，搜索 'OTP Mobile'，下载并安装到手机上",
  "t-installation-manual-android-2": "2-首次打开 otp mobile 应用程序时，您需要启用一系列权限以防止在使用过程中出现问题建议用户启用这些权限",
  "t-installation-manual-android-3": "3-使用“扫描”功能扫描电子邮件中的二维码信息以激活令牌",
  "t-installation-manual-android-4": "4-激活成功后，在应用程序界面上会显示OTP值",
  "t-installation-manual-android-5": "5-普通用户登录时，如果其所属的合作伙伴已启用双因素身份验证，则需要填写密码才能登录",
  "t-otp-mobile-installation-manual-ios": "手机令牌（IOS）安装手册",
  "t-installation-manual-ios-1": "1-进入 App Store，搜索 'otp mobile token'，下载并安装到手机上",
  "t-installation-manual-ios-2": "2-打开 otp mobile 应用程序",
  "t-installation-manual-ios-3": "3-使用“扫描”功能扫描电子邮件中的二维码信息以激活令牌",
  "t-installation-manual-ios-4": "4-激活成功后，在应用程序界面上会显示OTP值",
  "t-installation-manual-ios-5": "5-普通用户登录时，如果他所属的合作伙伴已启用双因素身份验证，则需要填写密码登录",
  "t-password-configuration": "密码配置",
  "t-passeord-use-least-one-uppercase-letter": "至少使用一个大写字母",
  "t-not-allows-use-special-characters": "不允许使用特殊字符",
  "t-not-allows-use-chinese-special-characters": "不允许使用中文特殊字符",
  "t-default-template": "默认模板",
  "t-user-changed-to-partner": "角色更改为合作伙伴：{param}",
  "t-smart-terminal-operations-remote-manager": "智能终端操作远程管理器",
  "t-account-profile": "配置文件",
  "t-sign-out": "退出",
  "t-merchant-portal": "商户门户",
  "t-storm": "STORM",
  "t-init-key": "初始化密钥",
  "t-password-does-not-match": "密码不匹配",
  "t-password-changed": "密码已更改, 请登录",
  "t-selectd-devices": "所选设备",
  "t-store-not-associated": "商店未关联",
  "t-push-group": "组",
  "t-error-loading-group-device": "加载组内设备时发生错误",
  "t-reset-password-link-invalid": "密码更改失败：该链接无效",
  "t-changed-password": "更改密码",
  "t-continue": "继续",
  "t-invalid-credentials": "凭据无效",
  "t-storm-version-release-notes": "STORMV1-3-3发布说明",
  "t-version-notes-content": "在此版本发布中，我们重点关注报告模块，固定报告将为您提供来自不同模块的数据的总体视图",
  "t-version-notes-one-title": "报表管理：静态报表",
  "t-version-notes-one-content": "STORM 现在为您提供了此报表生成功能，STORM 可以从不同角度生成多种报表格式：设备、应用程序、固件、推送和生命周期。还支持PDF、Excel格式的报表",
  "t-version-notes-two-title": "设备网络状态",
  "t-version-notes-two-content": "我们现在提供各种颜色来表示不同设备的状态，这样用户可以更快速地了解设备的当前网络状态",
  "t-version-notes-two-content-green": "绿色：在线",
  "t-version-notes-two-content-red": "红色：离线",
  "t-version-notes-two-content-orange": "橙色：超出地理围栏",
  "t-version-notes-two-content-blue": "蓝色：待激活",
  "t-version-notes-two-content-grey": "灰色：未激活",
  "t-version-notes-three-title": "推送报告",
  "t-version-notes-three-content": "STORM 提供了一种明显的方式来说明推送状态，无论推送成功、失败或进行中，用户都可以根据特定颜色和数字在第一眼看到状态。此外，用户可以在较早的情况下撤销推送，这意味着请求尚未被推送到设备端",
  "t-version-optimisaziton-points": "优化点：",
  "t-version-optimisaziton-points-one-title": "合作伙伴选择更新",
  "t-version-optimisaziton-points-one-content": "以前我们只提供了一种搜索合作伙伴名称的方式，现在我们提供了选择和搜索框两种方法，以适应不同的用户视角",
  "t-version-optimisaziton-points-two-title": "设备Excel导出报告",
  "t-version-optimisaziton-points-two-content": "在Excel中，有关于特定设备的更详细信息，因此用户只需在1个Excel中获得更多信息",
  "t-version-optimisaziton-points-three-title": "应用程序推送通知",
  "t-version-optimisaziton-points-three-content": "当将应用程序推送到一组设备时，如果一个或多个设备未与客户级别绑定，将会弹出通知",
  "t-certificate-file": "证书文件",
  "t-select-certificate-file": "选择证书文件",
  "t-cannot-empty-existing-imei": "无法清空现有的Imei",
  "t-required-payment-certificate-name": "TLS证书名称是必填项",
  "t-payment-certificate-saved-successfully": "TLS证书保存成功",
  "t-payment-certificate-deleted-successfully": "TLS证书{param}删除成功！",
  "t-error-deleting-payment-certificate": "删除TLS证书时发生错误",
  "t-select-start-end-time-limit": "检查时间跨度不能超过3个月",
  "t-select-multiple-options": "请至少选择一个筛选条件",
  "t-warning-to-delete-payments": "您确定要删除TLS证书 - {param}吗？",
  "t-delete-device-payments": "删除TLS证书确认",
  "t-enable_tid": "编辑TID",
  "t-key-expired": "密钥已过期，请创建一个新密钥，以防密钥索引重复",
  "t-sub-partner": "子合作伙伴",
  "t-open-enable-otp": "管理员启用OTP",
  "t-otp-identification-code": "令牌识别代码",
  "t-token-identification-code-setting": "(手机令牌应用 -> 设置 -> 关于)",
  "t-required-identification-code": "令牌识别代码是必填项",
  "t-enter-otp-code": "输入令牌识别代码",
  "t-generate-qr-code": "生成二维码",
  "t-otp-code-to-active": "输入OTP码以激活：",
  "t-enter-otp-code-to-active": "输入OTP码",
  "t-generated-code": "激活码",
  "t-enter-generated-code-to-active": "输入激活码",
  "t-required-otp-code": "OTP码是必填项",
  "t-identification-code-criteria": "OTP识别码由数字组成",
  "t-otp-code-criteria": "OTP码由数字组成",
  "t-please-generate-qr-code": "请先获取二维码",
  "t-enable-update-token": "替换令牌",
  "t-active-otp-success": "激活OTP成功！",
  "t-error-enter-minlength-identification-code": "令牌识别码的长度不能小于20",
  "t-bind-token-sn": "用户已绑定令牌（令牌编号：",
  "t-activation-otp": "激活OTP",
  "t-activation-otp-link-invalid": "激活OTP失败：该链接无效",
  "t-generate-qr-code-failed": "生成二维码失败",
  "t-activation-otp-failed": "激活OTP失败",
  "t-error-reset-password": "重置密码失败",
  "t-error-download-repeat": "文件已下载，请不要重复下载",
  "t-profile-application-layout": "如果您已打开应用程序签名功能（表示您已上传应用程序证书），请确保您的设备绑定到特定的客户！",
  "t-export-to-json": "导出为JSON文件",
  "t-device-status": "设备状态",
  "t-versions": "版本",
  "t-search-application": "应用程序",
  "t-tls-certificate-import": "TLS证书导入",
  "t-tls-certificate-bulk-upload": "TLS证书批量上传",
  "t-import-tls-certificate": "导入TLS证书",
  "t-import-tls-certificate-information-details": "导入TLS证书信息详情",
  "t-tls-file-name": "文件名：{param}",
  "t-push-confirm": "推送确认",
  "t-install-cer": "安装-cer",
  "t-push-confirm-desc": "请确认您要将所有证书推送到压缩文件中包含的设备",
  "t-tls-certificate": "TLS证书",
  "t-add-event": "添加事件",
  "t-modified-date": "修改日期",
  "t-main-log": "主日志",
  "t-bluetooth": "蓝牙",
  "t-kernel-log": "内核日志",
  "t-security-processor-log": "安全处理器日志",
  "t-pos-server-log": "POS服务器日志",
  "t-log-seconds": "秒",
  "t-log-mins": "分钟",
  "t-log-hour": "小时",
  "t-log-hours": "小时",
  "t-previous": "上一步",
  "t-today": "今天",
  "t-month-view": "月视图",
  "t-week-view": "周视图",
  "t-day-view": "日视图",
  "t-message-version": "消息版本",
  "t-search-firmware-version": "固件版本",
  "t-capturen-not-start": "抓取未开始",
  "t-capture-completed": "抓取完成",
  "t-capture-failed": "抓取失败",
  "t-capturing": "抓取中",

  "t-modelversion": "型号版本",
  "t-firmwareversion": "固件版本",
  "t-applicationversion": "应用程序版本",
  "t-keymanagement": "密钥管理",
  "t-message-management": "消息管理",
  "t-pushmanagement": "推送管理",
  "t-importmanagement": "导入管理",
  "t-logmanagement": "日志管理",

  "t-ui-mgmt": "UI管理",
  "t-roles---permissions": "角色权限",
  "t-certificate-mgmt": "证书管理",
  "t-rki-certificate": "RKI 证书",
  "t-application-certificate": "应用程序证书",

  "t-under_activation": "待激活",

  "t-block~disable": "BLOCK~DISABLE",
  "t-disable~block": "DISABLE~BLOCK",

  "t-kiosk-mode-activated": "霸屏模式激活",
  "t-install-app": "安装应用程序",
  "t-firmware-incremental-upgrade": "固件增量升级",
  "t-firmware-full-package": "固件升级",
  "t-restart-device": "重启设备",
  "t-storm-factory-reset-device": "恢复出厂设置 - STORM",
  "t-device-factory-reset-device": "恢复出厂设置 - Device",
  "t-unlock-device": "解锁设备",

  "t-device-initialization": "设备初始化",
  "t-start-log-capture": "开始日志抓取",
  "t-stop-log-capture": "停止日志抓取",
  "t-erase-tamper": "解除拆机",

  "t-payment-application-certificate": "支付应用程序证书",
  "t-automatic-active": "自动激活",
  "t-device-automatic-initialization": "设备自动初始化",
  "t-transaction-parameter": "交易参数",
  "t-not-yet-executed": "尚未执行",
  "t-application---full-package": "应用程序 - 整包",
  "t-application---batch-update": "应用程序 - 差分包",
  "t-factory-reset-device-storm": "恢复出厂设置 - STORM",
  "t-factory-reset-device-device": "恢复出厂设置 - DEVICE",
  "t-please-improve-tid": "请完善tid",
  "t-please-clear-tid-bind": "请清除所有与序列号相关的TID",
  "t-profile-application-fail-cause": "应用程序处理状态",
  "t-profile-uisettings-fail-cause": "主题处理状态",
  "t-profile-systemparam-fail-cause": "系统参数处理状态",
  "t-profile-application-name": "应用程序名称",
  "t-profile-application-version-name": "应用程序版本名称",
  "t-profile-firmware-fail-cause": "固件失败原因",
  "t-profile-firmware-processing-status": "固件处理状态",
  "t-profile-firmware-name": "固件名称",
  "t-profile-firmware-version-name": "固件版本名称",
  "t-profile-fail-cause": "失败原因",
  "t-profile-uisettings-name": "主题名称",
  "t-profile-uisettings-version-name": "主题版本名称",
  "t-profile-systemparam-name": "系统参数名称",
  "t-profile-systemparam-version-name": "系统参数版本名称",
  "t-profile-systemparam-version": "系统参数版本",
  "t-error-geo-fence-action-list": "操作列表不能为空",
  "t-error-geo-fence-region-list": "区域列表不能为空",
  "t-error-geo-fence-action": "操作不能为空",
  "t-maximize": "最大化",
  "t-dashboard-widget-selection": "仪表板小部件选择",
  "t-ui-management-version": "UI管理版本",
  "t-system-params-version": "系统参数版本",
  "t-action-create": "创建",
  "t-action-update": "更新",
  "t-action-delete": "删除",
  "t-add-region": "添加区域",
  "t-password-configuration-select": "至少选择一个密码策略",
  "t-network-try-again": "网络错误，请重试",
  "t-connection-time-out": "连接超时，请重试",
  "t-test-connection": "测试连接",
  "t-connection-test-success": "连接测试成功",
  "t-connection-test-failed": "连接测试失败",
  "t-application-signed-failed": "应用签名失败",
  "t-add-profile-check-application": "确保签名APK成功检测到",
  "t-tid-require-valid": "如果填写TID，则需要填写国家和地区",
  "t-file-upload": "文件上传",
  "t-application-control": "应用程序控制",
  "t-remove-uninstall-block": "移除禁止卸载",
  "t-remove-password": "移除密码",
  "t-app-set-uninstall-block": "应用设置禁止卸载",
  "t-app-remove-uninstall-block": "应用移除禁止卸载",
  "t-app-set-password": "应用设置密码",
  "t-app-remove-password": "应用移除密码",
  "t-configuration-success": "应用程序设置已发送到设备",
  "t-error-enter-minlength-password": "密码长度不能小于6",
  "t-error-enter-password": "密码是必填项",
  "t-warning-to-remove-uninstall-block": "您确定要移除禁止卸载应用吗？",
  "t-warning-to-logout": "您确定要退出登录吗？",
  "t-email-name-required": "电子邮件设置名称是必填项",
  "t-email-created-successfully": "邮箱配置{param}创建成功！",
  "t-email-updated-successfully": "邮箱配置{param}更新成功！",
  "t-error-creating-email": "创建邮箱配置时发生错误",
  "t-error-updating-email": "更新邮箱配置时发生错误",
  "t-enable-email-success": "邮箱配置已启用成功",
  "t-enable-email-close": "邮箱配置已成功关闭",
  "t-enable-email-fail": "启用邮箱配置失败",
  "t-delete-email-error": "邮箱配置已启用，不能删除！",
  "t-search-email": "电子邮件",
  "t-warning-delete-email": "您确定要删除邮箱配置 - {param} 吗？",
  "t-delete-email-confirmation": "删除邮箱配置确认",
  "t-email-deleted": "邮箱配置已成功删除！",
  "t-add-email": "添加电子邮件",
  "t-edit-email": "编辑电子邮件",
  "t-enter-email-name": "输入电子邮件名称",
  "t-enter-email-server": "输入电子邮件服务器",
  "t-enter-port": "输入端口",
  "t-enter-email-account": "输入电子邮件帐号",
  "t-enter-email-sender": "输入电子邮件发送者",
  "t-required-email-sender": "电子邮件发送者是必填项",
  "t-error-email-name-pattern": "电子邮件名称由字母、数字、下划线、点和空格组成，不能以空格开头或结尾",
  "t-error-email-server-required": "电子邮件服务器是必填项",
  "t-error-email-account-required": "电子邮件帐户是必填项",
  "t-error-email-port-required": "端口是必填项",
  "t-error-email-port-pattern": "端口应在1-65535之间",
  "t-error-email-host-pattern": "请输入合法的邮件服务器",
  "t-search-key": "密钥",
  "t-search-push-detail": "搜索推送详细信息",
  "t-search-push-event": "搜索推送事件",
  "t-search-log-capture-event": "搜索日志",
  "t-search-partner-setting": "合作伙伴",
  "t-search-ui-settings-version": "搜索UI设置版本",
  "t-search-payment-application-certificate": "TLS证书",
  "t-search-message-sidebar": "搜索合作伙伴",
  "t-email-setting-connection-success": "电子邮件设置连接成功",
  "t-email-setting-connection-failed": "电子邮件设置连接失败",
  "t-lat-and-lng": "经度和纬度",
  "t-version-low-to-upgrade": "当前版本过低不支持此功能，请升级版本",
  "t-email-settings-enable-ssl": "启用SSL",
  "t-email-settings-enable-starttls": "启用STARTTLS",
  "t-email-settings-meanwhile-enbale": "无法同时启用SSL协议和TLS协议",
  "t-error-update-application": "更新应用程序失败",
  "t-file-size-bigger": "文件大小过大",
  "t-error-bind-device": "设备绑定失败",
  "t-error-unbind-device": "设备解绑失败",
  "t-required-transaction-param-version-name": "交易参数版本名称是必填项",
  "t-required-package-name": "包名称是必填项",
  "t-required-intent-name": "intent名称是必填项",

  "t-upload-file": "上传文件",
  "t-deleted": "删除",
  "t-customer-name": "客户名称",
  "t-store-name": "商店名称",
  "t-expired-at": "过期时间",
  "t-hsm-model-name": "Hsm型号名称",
  "t-pushes": "推送",
  "t-is-batch-upload": "批量上传",
  "t-system-param-name": "系统参数名称",

  "t-model-type": "型号类型",
  "t-model-type-required": "设备类型是必填项",
  "t-smart-pos": "智能POS",
  "t-id-pos": "ID POS",
  "t-mpos": "MPOS",
  "t-folder-name": "文件夹名称",
  "t-batch-devices-details": "批量绑定/解绑设备信息详细信息",
  "t-execute-date": "执行日期",
  "t-expired-date": "过期日期",
  "t-empty-device-password": "当前设备尚未设置密码锁",
  "t-pubkey-is-normal-no-need-to-sync": "公钥正常，无需同步",
  "t-task-scheduler-name": "系统定时任务名称",
  "t-add-task-scheduler": "添加系统定时任务",
  "t-edit-task-scheduler": "编辑系统定时任务",
  "t-delete-task-scheduler": "删除系统定时任务",
  "t-warning-delete-task-scheduler": "您确定要删除系统定时任务-{param}?",
  "t-task-scheduler-deleted": "系统定时{param}任务删除成功！",
  "t-error-deleting-task-scheduler": "删除系统定时任务时发生错误",
  "t-second": "秒",

  "t-cycle-by": "周期",
  "t-not-specified": "未指定",
  "t-follow": "跟随",
  "t-this-month": "本月",
  "t-this-week": "本周",
  "t-specified": "指定",
  "t-last-five-runs": "最近5次运行",
  "t-permissible-wildcards": "允许通配符",
  "t-last": "最后",
  "t-monthly": "每月",
  "t-most-recent-working-day": "最近的工作日",
  "t-warning-execute-task-scheduler": "确认立即执行' {param} '任务吗？",
  "t-error-execute-task-scheduler": "执行系统定时任务时发生错误",
  "t-enable-task-scheduler-success": "系统定时任务启用成功",
  "t-enable-task-scheduler-close": "系统定时任务关闭成功",
  "t-enable-task-scheduler-fail": "启用系统定时任务失败",
  "t-please-select-model-version": "请选择型号版本！",
  "t-path": "路径",
  "t-rom-version": "ROM版本",
  "t-k21-version": "K21版本",
  "t-memory-total": "总内存",
  "t-memory-available": "可用内存",
  "t-flash-total": "总闪存",
  "t-flash-available": "可用闪存",
  "t-battery": "电池",
  "t-model-type-exist": "型号类型已存在，请删除现有数据后重新添加",
  "t-model-functions": "型号功能",
  "t-error-enter-valid-cleancondition": "清除条件只能输入数字",
  "t-cleancondition": "清除条件",
  "t-set-version-type": "设置版本类型",
  "t-not-support-log-capture": "传统终端不支持手动抓取日志",
  "t-example": "示例",
  "t-type-of-30-second": "类型1表示30秒",
  "t-type-of-60-second": "类型2表示60秒",
  "t-example-of-capture": "{\"fileName\"t-:\"11.txt\"t-,\"path\"t-:\"\"t-,\"type\"t-:\"\"t-}",
  "t-push-scheduled-tasks": "推送计划任务记录",

  "t-executing": "正在执行",
  "t-task-created": "任务已创建",
  "t-search-push-scheduled-tasks": "搜索推送计划任务记录",
  "t-res[i]-name": "您确定要撤销推送计划任务吗？",
  "t-push-scheduled-tasks-abort-successfully": "撤销推送计划任务成功！",
  "t-error-push-scheduled-tasks-abort": "撤销推送计划任务时发生错误",
  "t-error-version-type-required": "版本类型是必填项",
  "t-not-support-log-capture-if-id": "此身份验证终端的协议类型不支持抓取日志",
  "t-cancel-push-success": "撤销推送成功",
  "t-error-enter-maxlength-password": "密码长度必须是6位",
  "t-not-allow-same-duration": "不允许使用相同的持续时间",
  "t-signature-file-currently-creating": "当前正在创建签名文件",
  "t-differential-package-creating": "正在生成差分包",
  "t-connection-type-required": "连接方式是必填项",
  "t-message-protocol-required": "消息协议是必填项",
  "t-apk": "APK",
  "t-zip-dat": "ZIP|DAT",
  "t-file-type-required": "文件类型是必填项",
  "t-no-preview-available-tiff": "TIFF文件无法预览",
  "t-inconsistent-apk-signatures-unable-push-patch-file": "应用程序签名不一致，无法推送差分文件",
  "t-enter-push-event-name": "输入推送计划任务名称",
  "t-downloading": "下载中",
  "t-batch-delete": "批量删除",
  "t-confirm-batch-delete": "确定要删除这 {count} 个项目？",
  "t-batch-delete-devices": "批量删除设备",
  "t-batch-delete-select-at-least-one": "请至少选择一项",
  "t-batch-delete-invalid-id-format": "无效的 ID 格式",
  "t-batch-delete-some-items-not-exist": "部分项目不存在",
  "t-batch-delete-request-failed": "批量删除请求失败",
  "t-batch-delete-no-permission": "没有批量删除权限",
  "t-batch-delete-success-count": "成功删除 {count} 个项",
  "t-search-by-group-name": "按名称搜索组",
  "t-search-device-by-sn-tid-mid": "按序列号、TID、MID搜索设备",
  "t-batch-delete-device": "删除设备",
  "t-batch-delete-devices-details": "批量删除设备信息",
  "t-input-invalid-apk-password": "密码只能输入数字-",
  "t-batch-enable-disable-device": "批量启用和禁用设备",
  "t-search-by-firmware": "按固件名称搜索",
  "t-search-by-firmware-version": "按固件版本名称搜索",
  "t-batch-disable-device": "批量禁用设备",
  "t-search-by-application": "按应用名称搜索",
  "t-search-by-application-version": "按应用版本名称搜索",
  "t-partner-mgmt": "合作伙伴管理",
  "t-customer-mgmt": "客户管理",
  "t-merchant-mgmt": "商户管理",
  "t-system-general-parameter": "通用参数",
  "t-add-wallpaper": "添加壁纸",
  "t-enter-wallpaper-name": "输入壁纸名称",
  "t-wallpaper-name-required": "壁纸名称是必填项-",
  "t-add-boot-picture": "添加开机第一帧",
  "t-enter-boot-picture-name": "输入开机第一帧名称",
  "t-boot-picture-name-required": "开机第一帧名称是必填项-",
  "t-add-boot-animation": "添加开机动画",
  "t-enter-boot-animation-name": "输入开机动画名称",
  "t-boot-animation-name-required": "开机动画名称是必填项-",
  "t-boot-picture-file": "开机第一帧文件",
  "t-boot-animation-file": "开机动画文件",
  "t-preview-wallpaper": "预览壁纸",
  "t-preview-boot-picture": "预览开机第一帧",
  "t-preview-boot-animation": "预览开机动画",
  "t-retract": "收起",
  "t-expand": "展开",
  "t-app-mgmt": "应用管理",
  "t-install-immediately-after-downloading": "下载后立即安装",
  "t-install-immediately-for-tips": "提示：可能会影响客户正在进行的操作",
  "t-select-installation-period": "选择安装时段",
  "t-automatic-upgrade-after-startup": "开机后自动升级",
  "t-specify-the-first-time-after-downloading": "Specify the time from the first time after downloading the file",
  "t-support-upgrade-strategy-for-version-code": "SMA版本 XXX 及以上支持此升级策略-",
  "t-installation-time-greater-than-current-time": "安装时间应大于当前时间",
  "t-installation-time": "安装时间",
  "t-please-select-installation-time": "请选择下载文件后的第一个时间-",
  "t-key-mgmt": "密钥管理",
  "t-firmware-mgmt": "固件管理",
  "t-system-settings": "系统设置",
  "t-search-sn-tid-mid": "SN、TID、MID、IMEI",
  "t-search-sn-mid": "SN、MID、IMEI",
  "t-search-sn-tid": "SN、TID",
  "t-search-name-mid": "NAME、MID",
  "t-search-wallpaper": "壁纸",
  "t-search-boot-picture": "开机第一帧",
  "t-search-boot-animation": "开机动画",
  "t-search-hardware-parameter": "硬件参数",
  "t-batch-operate-device": "设备批量操作",
  "t-import-device": "导入设备",
  "t-apps-list": "应用",
  "t-app-certificates": "应用证书",
  "t-on-board-merchants": "注册商户",
  "t-device-status-tampered": "拆机",
  "t-device-status-out-of-country": "超出国家地区围栏",
  "t-device-status-out-of-fence": "超出地理围栏",
  "t-device-status-online": "在线",
  "t-device-status-offline": "离线",
  "t-device-status-disabled": "禁用",
  "t-edit-wallpaper": "编辑壁纸",
  "t-edit-boot-picture": "编辑开机第一帧",
  "t-edit-boot-animation": "编辑开机动画",
  "t-action-name": "操作名称",
  "t-currencyName": "货币",
  "t-add-hardware-parameter": "添加硬件参数",
  "t-edit-hardware-parameter": "编辑硬件参数",
  "t-add-system-general-parameter": "添加常规参数",
  "t-edit-system-general-parameter": "编辑常规参数",
  "t-error-push-search": "推送查询",
  "t-boot-picture-version-saved-successfully": "上传开机第一帧文件成功",
  "t-warning-unbind-device-for-group": "您确实要解绑设备 -{param} ?",
  "t-unbind-device-confirmation": "解绑设备确认",
  "t-enable-device": "启用设备",
  "t-warning-delete-role": "您确定要删除角色-{param} ?",
  "t-confirmation-delete-role": "删除角色确认",
  "t-select-valid-manufacturer": "请选择有效的厂商",
  "t-add-delete-device": "添加/删除 设备",
  "t-add-tls-certificate": "添加TLS证书",
  "t-delete-device-information-details": "删除设备信息详细信息",
  "t-enable-device-information-details": "启用设备信息详细信息",
  "t-disable-device-information-details": "禁用设备信息详细信息",
  "t-add-search-device": "添加设备到组",
  "t-error-enable-device": "启用设备时发生错误",
  "t-error-disable-device": "禁用设备时发生错误",
  "t-user-sourse": "用户来源",
  "t-start-time-than-end-time-one-hour": "计划开始时间和计划结束时间必须大于三十分钟",
  "t-enter-tid": "输入TID",
  "t-enter-hardware-param-version-name": "输入硬件参数名称",
  "t-required-hardware-param-version-name": "硬件参数名称是必填项-",
  "t-enter-system-general-param-version-name": "输入系统通用参数名称",
  "t-required-system-general-param-version-name": "系统通用参数名称是必填项-",
  "t-import-failed-info": "导入失败：",
  "t-import-file-not-allow-special-characters": "上传的文件名称不允许包含特殊字符-",
  "t-dateYear": "年份",
  "t-num": "数量",
  "t-placeholder-enter-device-secret": "请输入设备密钥",
  "t-placeholder-enter-product-key": "请输入产品密钥",
  "t-error-enter-device-secret": "设备密钥是必填项-",
  "t-error-enter-product-key": "产品密钥是必填项-",
  "t-error-product-key-pattern": "设备密钥只允许输入大写字母和数字-",
  "t-warning-delete-boot-animation": "您确定要删除开机动画 - {param} 吗？",
  "t-confirmation-delete-boot-animation": "删除开机动画确认",
  "t-warning-delete-boot-picture": "您确定要删除开机第一帧 - {param} 吗？",
  "t-confirmation-delete-boot-picture": "删除开机第一帧确认",
  "t-warning-delete-wallpaper": "您确定要删除壁纸 - {param} 吗？",
  "t-confirmation-delete-wallpaper": "删除壁纸确认",
  "t-delete-system-general-parameter-version-confirmation": "删除通用参数版本确认",
  "t-warning-delete-system-general-parameter-version": "您确定要删除通用参数版本 - {param} 吗？",
  "t-system-general-parameter-version-deleted-successfully": "通用参数版本{param}删除成功！",
  "t-error-deleting-system-general-parameter-version": "删除通用参数版本时发生错误",
  "t-system-general-parameter-version": "通用参数版本",
  "t-delete-hardware-parameter-version-confirmation": "删除硬件参数版本确认",
  "t-warning-delete-hardware-parameter-version": "您确定要删除硬件参数版本 - {param} 吗？",
  "t-hardware-parameter-version-deleted-successfully": "硬件参数版本{param}删除成功！",
  "t-error-deleting-hardware-parameter-version": "删除硬件参数版本时发生错误",
  "t-hardware-parameter-version": "硬件参数版本",
  "t-system-general-parameter-version-created-successfully": "通用参数版本{param}创建成功！",
  "t-error-creating-system-general-parameter-version": "创建通用参数版本时发生错误",
  "t-error-loading-system-general-parameter-version": "硬件参数版本{param}创建成功！",
  "t-hardware-parameter-version-created-successfully": "硬件参数版本{param}创建成功！",
  "t-error-creating-hardware-parameter-version": "创建系统通用参数版本时发生错误-",
  "t-error-loading-hardware-parameter-version": "创建硬件参数版本时发生错误-",
  "t-boot-animation-saved-successfully": "开机动画 {param} 保存成功！",
  "t-boot-picture-saved-successfully": "开机第一帧 {param} 保存成功！",
  "t-wallpaper-saved-successfully": "壁纸 {param} 保存成功！",
  "t-boot-animation-updated-successfully": "开机动画 {param} 更新成功！",
  "t-boot-picture-updated-successfully": "开机第一帧 {param} 更新成功！",
  "t-wallpaper-updated-successfully": "壁纸 {param} 更新成功！",
  "t-error-updating-boot-animation": "更新开机动画时发生错误",
  "t-error-updating-boot-picture": "更新开机第一帧时发生错误",
  "t-error-updating-wallpaper": "更新壁纸时发生错误",
  "t-error-creating-boot-animation": "创建开机动画时发生错误",
  "t-error-creating-boot-picture": "创建开机第一帧时发生错误",
  "t-error-creating-wallpaper": "创建壁纸时发生错误",
  "t-error-loading-boot-animation": "加载开机动画时发生错误",
  "t-error-loading-boot-picture": "加载开机第一帧时发生错误",
  "t-error-loading-wallpaper": "加载壁纸时发生错误",
  "t-load-more": "加载更多",
  "t-load-earlier-records": "查看更早",
  "t-timeline-hint": "当前仅展示近一年内的推送任务",
  "t-boot-animation-deleted-successfully": "开机动画 {param} 删除成功！",
  "t-boot-picture-deleted-successfully": "开机第一帧 {param} 删除成功！",
  "t-wallpaper-deleted-successfully": "壁纸 {param} 删除成功！",
  "t-error-deleting-boot-animation": "删除开机动画时发生错误",
  "t-error-deleting-boot-picture": "删除开机第一帧时发生错误",
  "t-error-deleting-wallpaper": "删除壁纸时发生错误",
  "t-recover-tamper-from-device": "您确定要解除设备拆机状态吗?",
  "t-enter-otp-from-email": "请输入邮件中的OTP",
  "t-enter-authorization-times": "输入授权次数",
  "t-allocate-authorization-updated-successfully": "更新分配授权 {param} 成功！",
  "t-error-allocate-authorization-updated-times": "更新分配授权次数时发生错误",
  "t-list-header-updated-successfully": "列表标题更新成功！",
  "t-list-header": "列表标题",
  "t-push-record": "推送记录",
  "t-devices-report": "设备报表",
  "t-dynamic-report-new": "动态报表-新",
  "t-fixed-report-new": "静态报表-新",
  "t-functional-module": "功能模块",
  "t-updated-successfully": "更新成功!",
  "t-required-report-name": "报表名称是必填项-",
  "t-required-report-attribute-name": "属性名称是必填项-",
  "t-required-report-language": "语言类型是必填项-",
  "t-deleted-successfully": "删除成功!",
  "t-push-name": "推送名称",
  "t-reduce": "减少",
  "t-increase": "增加",
  "t-enable-tamper-auth": "开启解除拆机验证",
  "t-otp": "OTP",
  "t-mfa": "双因素认证",
  "t-otp-password-sent-successfully": "otp口令发送成功!",
  "t-authorization-times-required": "授权次数是必填项",
  "t-resend-in": "重新发送",
  "t-status-indicates-scheduled-task": "此状态仅代表此计划任务已经被创建-",
  "t-update-authorization-times": "更新授权次数",
  "t-warning-delete-allocate-authorization": "您确定要删除分配授权-{param} ?",
  "t-allocate-authorization-deleted-successfully": "分配授权{param}删除成功！",
  "t-error-deleting-allocate-authorization": "删除分配授权时发生错误！",
  "t-please-enter-authorization-times": "请输入授权次数",
  "t-minimum-authorization-times": "授权次数最小值是1",
  "t-maximum-authorization-times": "授权次数最大值是10000",
  "t-detamper": "解除拆机",
  "t-error-loading-allocate-authorization": "加载分配授权时发生错误",
  "t-async-download": "异步下载",
  "t-generate": "生成",
  "t-background-audio": "背景音频",
  "t-upload-folder": "上传文件夹",
  "t-upload-folder-is-empty": "上传的文件为空",
  "t-upload-folder-maximum-length": "上传的文件长度最大不超过100",
  "t-upload-folder-minimum-length": "上传的文件长度最小不小于1",
  "t-number-of-cycles": "循环次数",
  "t-number-of-images-play-second": "每秒播放数量",
  "t-number-of-images-limited-sheets": "文件数量限制在1-100张之间",
  "t-wav": "Wav",
  "t-sheets": "张",
  "t-number-of-5": "1-5",
  "t-customize": "自定义",
  "t-license-information-name-required": "授权信息名字是必填项-",
  "t-upload-license-information-file": "上传授权文件",
  "t-edit-license-information": "编辑通知邮箱",
  "t-error-license-information-created": "创建授权信息时发生错误",
  "t-server-info": "授权服务器信息",
  "t-enable-server-authorization": "启用服务器授权",
  "t-specified-deployment-server-info": "指定部署服务器信息",
  "t-ip-address": "授权IP地址",
  "t-mac-address": "授权Mac地址",
  "t-authorization-period": "有效期",
  "t-expiration-time-authorization": "授权截至日期",
  "t-buffer-after-expiration": "授权到期后的宽限时间",
  "t-server-utc": "服务器所在时区",
  "t-enable-pre-expiration-alarms": "启用到期前告警",
  "t-time-to-send-alarm-emails": "截止日期前多少天发送邮件告警",
  "t-reminder-interval": "告警周期",
  "t-licensed-nums": "许可数量",
  "t-num-of-devices": "设备数量",
  "t-num-of-keys": "密钥数量",
  "t-device-tamper-times": "拆机数量",
  "t-num-of-partners": "Partner数量",
  "t-num-of-apps-installed": "应用数量",
  "t-num-of-firmwares": "固件数量",
  "t-num-of-users": "用户数量",
  "t-num-of-merchants": "商户账号数量",
  "t-num-of-transaction-params": "交易参数数量",
  "t-send-email-notifications": "发送告警",
  "t-others": "其他",
  "t-enable-ads": "广告",
  "t-enable-open-api": "OPEN API",
  "t-remaining": "剩余",
  "t-days": "天",
  "t-authorization-expiration-date": "授权截止日期",
  "t-please-charge-in-time": "请及时更新",
  "t-the-authorization-file-has-expired": "授权文件已到期",
  "t-upload-authorization-file": "请上传授权文件",
  "t-alarm-email": "通知邮箱",
  "t-enable-key-push": "密钥",
  "t-created-successfully": "保存成功",
  "t-auth-file-parsing-failed": "授权文件解析失败",
  "t-planned-push-after-auth-period": "计划任务执行时间不能大于授权有效期",
  "t-expired-by": "已过期",
  "t-task-created-successfully": "系统定时任务创建成功!",
  "t-error-creating-task": "创建系统定时任务时发生错误",
  "t-task-updated-successfully": "系统定时任务更新成功!",
  "t-error-updating-task": "更新系统定时任务时发生错误",
  "t-player-second-cannot-exceed-total": "每秒播放次数不能超过总数",
  "t-function-name": "业务类型名称",
  "t-key-block-value": "密钥块值",
  "t-enter-key-block-value": "输入密钥块值",
  "t-required-key-block-value": "密钥块值是必填项",
  "t-enter-lmk-index": "输入LMK索引",
  "t-required-lmk-index": "LMK索引是必填项",
  "t-required-currency-code": "货币是必填项",
  "t-required-country-code": "国家是必填项",
  "t-terminal-action-analysis": "生成终端代码",
  "t-copy-close": "复制和关闭",
  "t-add-tid": "添加TID",
  "t-update-tid": "更新TID",
  "t-delete-tid": "删除TID",
  "t-server-mdm-delete-profile-error": "终端初始化文件已启用，无法删除！",
  "t-required-tid": "Tid是必填项",
  "t-device-to-swap": "待交换的设备",
  "t-swap": "交换",
  "t-swap-tid": "交换TID",
  "t-menu-start-color": "菜单起始颜色",
  "t-menu-end-color": "菜单结束颜色",
  "t-menu-text-color": "菜单文字颜色",
  "t-partner-icon": "合作伙伴门户标志",
  "t-cloud-message-push-history": "云消息推送历史记录",
  "t-push-history": "推送历史记录",
  "t-expiry-unlimited": "无限期",
  "t-enable-cloud-messaging": "云消息",
  "t-receipt-layout-details": "收据布局详情",
  "t-receipt-type": "收据类型",
  "t-layout-name": "布局名称",
  "t-receipt-layout": "收据布局",
  "t-receipt-created": "创建收据",
  "t-receipt-updated": "更新收据",
  "t-default-layout": "默认布局",
  "t-add-new-row": "添加新行",
  "t-add-new-column": "添加新列",
  "t-create-row": "创建行",
  "t-update-row": "更新行",
  "t-other": "其他",
  "t-full-screen": "全屏",
  "t-display": "显示",
  "t-row-number": "行号",
  "t-text-style": "文本样式",
  "t-text-align": "文本对齐",
  "t-receipt-rows": "收据行",
  "t-label": "标签",
  "t-onboard-merchant": "注册商户",
  "t-feitian-iam": "飞天认证平台",
  "t-feitian-partner": "飞天伙伴平台",
  "t-user-activated": "商户用户已激活",
  "t-error-user-activation": "激活商户用户时发生错误",
  "t-mobile-activated": "手机已激活",
  "t-kyc-completed": "KYC已完成",
  "t-onboard-application": "注册商户",
  "t-personal": "个人资料",
  "t-mobile-number": "手机号码",
  "t-date-of-birth": "出生日期",
  "t-enter-date-of birth": "请输入出生日期",
  "t-citizenship": "国籍",
  "t-company": "公司信息",
  "t-country-of-registration": "注册国家",
  "t-legal-form": "法律形式",
  "t-company-name": "公司名称",
  "t-contact-number": "联系电话",
  "t-contact-person": "联系人",
  "t-business-sector": "业务部门",
  "t-business-activity": "业务活动",
  "t-registered-company-street": "注册公司街道",
  "t-registered-company-house-number": "注册公司门牌号",
  "t-registered-company-city": "注册公司城市",
  "t-registered-company-zip": "注册公司邮政编码",
  "t-registered-company-country": "注册公司国家",
  "t-tax-country": "纳税国家",
  "t-tax-id": "税务登记号",
  "t-bank": "银行信息",
  "t-account-holder-name": "账户持有人名称",
  "t-account-type": "账户类型",
  "t-account-currency": "账户货币",
  "t-bank-name": "银行名称",
  "t-account-number": "账号",
  "t-additional": "附加信息",
  "t-intent-of-use": "使用意图",
  "t-source-of-use": "收入来源",
  "t-annual-turnover-foresee": "预计年度营业额",
  "t-expected-average-transaction-amount": "预期平均交易金额",
  "t-online-channel": "在线渠道",
  "t-documents": "文件",
  "t-bank-statement": "银行对账单",
  "t-id-proof": "身份证明",
  "t-address-proof": "地址证明",
  "t-address-proof1": "地址证明1",
  "t-alert-mgmt": "通知管理",
  "t-alert-settings": "报警设置",
  "t-add-alert": "添加报警设置",
  "t-edit-alert": "编辑报警设置",
  "t-notice-name": "通知名称",
  "t-notice-start-time": "通知生效时间",
  "t-alert-level-info": "一般",
  "t-alert-level-warn": "警告",
  "t-alert-level-critical": "严重",
  "t-day-and-time": "周",
  "t-notifying-email": "邮件",
  "t-add-alert-contacts-group": "添加联系人组",
  "t-edit-contacts-group": "编辑联系人组",
  "t-search-alert-contacts-group": "搜索联系人组名称",
  "t-contacts-group-name": "名称",
  "t-enter-contacts-group-name": "请输入联系人组名称",
  "t-error-contacts-group-name-required": "联系人组名称是必填项",
  "t-warning-delete-contactGroup": "您确定要删除联系组 - {param} 吗？",
  "t-add-alert-policy": "添加策略",
  "t-edit-alert-policy": "编辑策略",
  "t-search-alert-policy": "搜索策略名称",
  "t-warning-delete-policy": "您确定要删除策略 - {param} 吗？",
  "t-policy-name": "t-策略名称",
  "t-enter-policy-name": "请输入策略名称",
  "t-error-policy-name-required": "策略名称是必填项",
  "t-error-policy-rule-template-required": "规则模板是必填项",
  "t-add-alert-contacts-user": "添加联系人",
  "t-edit-contacts-user": "编辑联系人",
  "t-search-alert-contacts-user": "搜索名字",
  "t-attestation": "认证",
  "t-add-attestation": "添加认证",
  "t-error-attestation-created": "创建认证时发生错误",
  "t-error-attestation-updated": "更新认证时发生错误",
  "t-attestation-updated-successfully": "认证更新成功",
  "t-attestation-created-successfully": "认证创建成功",
  "t-attestation-deleted-successfully": "认证删除成功！",
  "t-error-deleting-attestation": "删除认证时发生错误",
  "t-search-attestation": "搜索认证",
  "t-warning-delete-attestation": "您确定要删除认证 - {param} 吗？",
  "t-error-deleting-attestation-version": "删除认证版本时发生错误",
  "t-attestation-history": "认证历史",
  "t-old-rule": "旧规则",
  "t-new-rule": "新规则",
  "t-view": "查看",
  "t-attestation-monitor": "认证监视器",

  "t-alert-status-info-unread": "未读",
  "t-notice-default-rule": "规则",
  "t-add-rule": "添加规则模板",
  "t-edit-rule": "编辑则模板",
  "t-search-rule": "搜索规则模板",
  "t-enter-alert-rule-name": "请输入规则名称",
  "t-error-alert-rule-name-required": "规则名称是必填项",
  "t-error-alert-name-required": "报警名称是必填项",
  "t-rule-template-fence-template-name": "电子围栏报警",
  "t-alert-rule-updated-successfully": "规则模板{param}更新成功！",
  "t-rule-template-tampered-template-name": "设备拆机报警",
  "t-enable-tampered-alert": "启用拆机报警",
  "t-enable-out-of-country": "启用国家围栏报警",

  "t-email-message": "邮件消息",
  "t-error-delay-time-required": "下一次通知间隔是必填项",
  "t-error-delay-time-max": "下一次通知间隔最大值:",
  "t-error-delay-time-min": "下一次通知间隔最大小值:1",
  "t-error-alert-channel-required": "通知渠道是必填项",
  "t-error-alert-weeks-required": "通知周是必填项",
  "t-add-email-alert-template": "添加邮件告报警模板",
  "t-add-alert-alarm-template": "添加邮件报警模板",
  "t-update-alert-template": "修改邮件报警模板",
  "t-search-alert-alarm-template": "模板标题",
  "t-please-select-the-person-to-alert": "请选择报警人员",

  "t-alert-settings-created-successfully": "报警设置 {param} 创建成功！",
  "t-error-created-alert-settings": "创建报警设置时发生错误",
  "t-alert-settings-updated-successfully": "报警设置 {param} 修改成功！",
  "t-error-update-alert-settings": "修改报警设置时发生错误",
  "t-alert-settings-deleted-successfully": "删除报警设置 {param} 删除成功！",
  "t-error-deleting-alert-settings": "删除报警设置时发生错误！",
  "t-contacts-user-created-successfully": "联系人用户创建成功！",
  "t-error-created-contacts-user": "创建联系人用户时发生错误",
  "t-contacts-user-updated-successfully": "联系人用户 {param} 修改成功！",
  "t-error-update-contacts-user": "修改联系人用户时发生错误",
  "t-contacts-user-deleted-successfully": "联系人用户 {param} 删除成功！",
  "t-error-deleting-contacts-user": "删除联系人用户时发生错误！",
  "t-contacts-group-created-successfully": "联系人组 {param} 创建成功！",
  "t-error-created-contacts-group": "创建联系人组时发生错误",
  "t-contacts-group-updated-successfully": "联系人组 {param} 修改成功！",
  "t-error-update-contacts-group": "修改联系人组时发生错误",
  "t-contacts-group-deleted-successfully": "删除联系人组 {param} 删除成功！",
  "t-error-deleting-contacts-group": "删除联系人组时发生错误！",
  "t-alerts-policy-created-successfully": "报警策略 {param} 创建成功！",
  "t-error-created-alerts-policy": "创建报警策略时发生错误",
  "t-alerts-policy-updated-successfully": "报警策略 {param} 修改成功！",
  "t-error-update-alerts-policy": "修改报警策略时发生错误",
  "t-alerts-policy-deleted-successfully": "删除报警策略 {param}删除成功！",
  "t-error-deleting-alerts-policy": "删除报警策略时发生错误！",
  "t-alert-template-created-successfully": "报警邮件模板 {param} 创建成功！",
  "t-alert-template-updated-successfully": "报警邮件模板 {param} 修改成功！",
  "t-error-updated-email-alert-template": "修改报警邮件模板时发生错误",
  "t-error-created-email-alert-template": "修改报警邮件模板时发生错误",
  "t-error-alert-email-template-title-required": "报警邮件模板标题是必填项",
  "t-error-alert-email-template-subject-required": "报警邮件模板主题是必填项",

  "t-error-update-alert-logs": "修改报警日志状态发生错误",
  "t-alert-logs-updated-successfully": "修改报警日志状态成功",
  "t-notifier": "通知人",
  "t-minimum-mobile-phone-number": "手机号码最少8位",
  "t-maximum-mobile-phone-number": "手机号码最多50位",
  "t-phone-duplicate":"电话重复",
  "t-email-duplicate":"邮箱重复",
  "t-select-valid-user-or-partner": "请选择必要的联系人",

  "t-add-sms-gateway": "添加短信网关",
  "t-edit-sms-gateway": "编辑短信网关",
  "t-enable-sms-success": "成功启用短信设置",
  "t-enable-sms-close": "短信设置关闭成功",
  "t-enable-sms-fail": "短信状态操作失败",
  "t-sms-deleted": "短信设置删除成功!",
  "t-error-deleting-sms-settings": "删除短信设置时发生错误！",
  "t-delete-sms-error": "短信设置已启用，无法删除!",
  "t-sms-settings-created-successfully": "t-短信设置创建成功！",
  "t-error-create-sms-settings": "t-创建短信设置时发生错误！",
  "t-sms-settings-updated-successfully": "短信设置更新成功！",
  "t-error-updated-sms-settings": "修改短信设置时发生错误",
  "t-sms-settings-accessKeySecret": "Access Key Secret",
  "t-error-sms-settings-accessKeyId-required": "短信设置中Access Key Id是必填项",
  "t-error-sms-settings-accessKeySecret-required": "短信设置中Access Key Secret是必填项",
  "t-error-sms-settings-signName-required": "短信设置中签名名称是必填项",
  "t-error-silence-time-required": "静默时间是必填项",
  "t-error-silence-time-min": "静默时间最少5分钟",
  "t-error-silence-time-max": "静默时间最多1440分钟",
  "t-enable-manufacturer": "厂商",
  "t-enable-tls-certificate": "TLS证书",
  "t-enable-ticket": "工单",
  "t-enable-merchant-user": "注册商户",
  "t-enable-attestation": "认证",
  "t-enable-sms": "短信设置",
  "t-enable-hsm": "HSM",
  "t-enable-geo-fence": "地理围栏",
  "t-enable-messages": "消息",
  "t-enable-report": "报表",
  "t-enable-transaction-param": "交易参数",
  "t-enable-cortex-scanner": "Cortex扫描器",
  "t-enable-system-health": "系统健康",
  "t-enable-task-scheduler": "任务调度器",
  "t-enable-feitian-partner": "飞天合作伙伴",
  "t-enable-feitian-iam": "飞天IAM",
  "t-enable-static-report": "静态报表",
  "t-enable-customize-report": "组件报表",
  "t-enable-widget-report": "动态报表",
  "t-enable-report-setting": "报表设置",
  "t-enable-otp": "MFA",
  "t-enable-notice": "报警管理",
  "t-enable-tamper": "解除拆机授权",
  "t-public-platform-type": "公有云平台",
  "t-use-password-length": "密码长度范围是4-32",
  "t-license-id": "授权ID",
  "t-user-deleted-successfully": "删除用户 {param}删除成功!",
  "t-error-deleting-user": "删除用户时发生错误!",
  "t-bind-unbind": "绑定/解绑",
  "t-device-has-been-bind-other-partner": "设备列表中有绑定到其他伙伴的设备(点击下载)",
  "t-device-has-been-bind-other": "设备列表中有绑定到其他伙伴/客户/商户/商店的设备",
  "tool": {
    "routerTitle": "报表设置",
    "addbtn": "添加分类",
    "reportName": "报表名称",
    "createTime": "创建时间",
    "createBy": "创建人",
    "updateTime": "更新时间",
    "updateBy": "更新人",
    "reportType": "报表类型",
    "universal": "通用",
    "custom": "控件",
    "popUp": "您确定要删除报表-{param}吗？",
    "delectTool": "删除报表",
    "sortAllocation": "分类配置",
    "conditions": "条件",
    "attributeCode": "属性代码",
    "attributeName": "属性名称",
    "dataType": "数据类型",
    "enumeratedValue": "枚举值",
    "enumerationName": "枚举名称",
    "sortDigit": "排序数字",
    "associatedPath": "关联路径",
    "associationSQL": "关联SQL",
    "chartType": "图表类型",
    "chartSQL": "图表SQL",
    "internationalization": "国际化",
    "languageType": "语言类型",
    "remark": "备注",
    "pleaseEnter": "请输入",
    "pieChart": "饼图",
    "barChart": "柱状图",
    "lineChart": "折线图",
    "string": "字符串",
    "time": "时间",
    "timeFrame": "时间范围",
    "enumeration": "枚举",
    "year": "年",
    "month": "月",
    "report": "报表"
  },
  "charts": {
    "fixedReport": "静态报表",
    "dynamicReport": "动态报表",
    "search": "搜索",
    "export": "导出",
    "editHeader": "编辑列表标题",
    "log": {
      "routerTitle": "推送记录",
      "partner": "合作伙伴",
      "customer": "客户",
      "merchant": "商户",
      "store": "商店",
      "modelCode": "型号版本",
      "perform": "执行动作",
      "execution": "执行时间",
      "result": "状态",
      "resultCause": "原因",
      "push.name": "名称"
    },
    "device": {
      "routerTitle": "设备",
      "sn": "序列号",
      "imei": "IMEI",
      "tid": "TID",
      "signalStrength": "网络",
      "status": "激活",
      "activateTime": "激活时间",
      "tamper": "拆机",
      "modelVersionName": "型号版本",
      "buildNum": "版本号",
      "spBootloader": "SP引导加载程序",
      "spFirmware": "SP固件",
      "smaVersionCode": "SMA版本号",
      "longitude": "经纬度",
      "keyName": "密钥",
      "partnerName": "合作伙伴",
      "customerName": "客户",
      "merchantName": "商户",
      "storeName": "商店",
      "merchantEmail": "商户邮箱",
      "storeEmail": "商店邮箱",
      "merchantPhone": "商户电话",
      "storePhone": "商店电话",
      "merchantAddress": "商户地址",
      "storeAddress": "商店地址",
      "merchantWebsite": "商户网址",
      "storeWebsite": "商店网址",
      "currency": "货币",
      "groupName": "组",
      "countryName": "区域",
      "lastOnlineTime": "上次在线时间",
      "lastDataUpdatedTime": "上次数据更新时间",
      "lastFactorySettingTime": "上次恢复出厂设置时间",
      "mid": "mid"
    },
    "model": {
      "head": "列表头",
      "applications": "应用（最多3个）"
    }
  },
  "t-api-key": "API Key",
  "t-api-secret": "API Secret",
  "t-online-status": "在线状态",
  "t-api-logs": "API调用日志",
  "t-api-parameters": "请求参数",
  "t-click-or-drag-file-upload-file": "单击或拖动文件到此区域进行上传",
  "t-input-invalid-pattern-special-char-name":"由数字、字母、下划线、点、逗号(英文)，空格和…、&、（、）、-、/、@组成，不能以空格开头或结尾。",
  "t-cancel-message": "取消消息",
  "t-cancel-ad": "取消广告",
  "t-warning-to-cancel-message": "您确定要取消消息吗？",
  "t-warning-to-cancel-ad": "您确定要取消广告吗？",
  "t-select-device-for-operation": "请选择要进行批量操作的设备",
  "t-select-operation-for-performed": "请选择要批量进行的操作",
  "t-themes": "主题",
  "t-theme-customizer": "主题定制器",
  "t-layout": "布局",
  "t-choose-layout": "选择布局",
  "t-color-scheme": "配色方案",
  "t-choose-color-scheme": "选择浅色或深色方案",
  "t-sidebar": "侧边栏",
  "t-choose-sidebar-size": "选择侧边栏的大小",
  "t-sidebar-color": "侧边栏颜色",
  "t-choose-sidebar-color": "选择浅色或深色的侧边栏颜色",
  "t-choose-sidebar-image": "选择侧边栏的图片",
  "t-light": "浅色",
  "t-dark": "深色",
  "t-vertical": "垂直",
  "t-horizontal": "水平",
  "t-small": "小",
  "t-gradient": "渐变",
  "t-add-more-notifier-tips": "要添加多个联系人，请使用\",\"来分隔它们",
  "t-items": "项",
  "t-push.abort.successfully": "撤销推送成功！",
  "t-events": "事件",
  "t-event": "事件",
  "t-working-time-period": "工作时间段",
  "t-repetition-interval-time": "重复间隔时间",
  "t-means-of-notification": "通知方式",
  "t-close-left-tabs": "关闭左侧标签页",
  "t-close-right-tabs": "关闭右侧标签页",
  "t-close-other-tabs": "关闭其他标签页",
  "t-parameter-settings": "参数设置",
  "t-transaction-mgmt": "交易管理",
  "t-parameter": "参数设置",
  "t-restore-default": "恢复默认设置",
  "t-device-extend-attribute": "设备扩展属性",
  "t-device-life-cycle": "设备生命周期",
  "t-otp-type-ft": "OTP Mobile",
  "t-otp-type-feitian": "Feitian OTP",
  "t-otp-type-google": "谷歌 Authenticator",
  "t-otp-google-download-detail": "下载安装",
  "t-otp-google-download-detail-2":"在你的手机",
  "t-otp-install-notes":" 安装说明",
  "t-otp-mobile-download":" 下载OTP Mobile 应用程序",
  "t-error-enter-otp-code": "动态口令长度为6-10位数字！",
  "t-scan-QRCode":"扫描二维码",
  "t-scan-QRCode-detail":"打开身份验证应用程序，使用手机的摄像头扫描左侧的图像",
  "t-otp-google-download":"下载身份验证器应用程序",
  "t-google-otp-link-invalid":"激活认证器失败：该链接无效",
  "t-product-model": "产品型号",
  "t-release-time": "发布时间",
  "t-wallpaper-format": "壁纸格式",
  "t-bootPicture-format": "开机第一帧格式",
  "t-BootAnimation-format": "开机动画格式",
  "t-model-version-identification": "型号版本标识",
  "t-enable-device-extend-attribute": "设备扩展属性",
  "t-enable-device-life-cycle": "设备生命周期",
  "t-is-empty": "{param} 不能为空",
  "t-error-updating-device-extend-attribute-value": "更新设备扩展属性值时发生错误",
  "t-enter-attribute-value": "输入扩展属性值",
  "t-server-attribute-type-string": "属性值长度：0-50;格式：字母、数字",
  "t-server-attribute-type-integer":"属性值应介于0-65535之间",
  "t-server-attribute-type-boolean": "属性值为布尔类型。请检查并修改",
  "t-device-extend-attribute-value-updated-successfully": "设备扩展属性值更新成功！",
  "t-export-to-csv": "导出CSV文件",
  "t-tooltip-device-tid": "SN、TID",
  "t-tid-list": "TID列表",
  "t-device-life-cycle-desc": "生命周期描述",
  "t-device-life-cycle-modifyTime": "生命周期修改时间",
  "t-fence-boundary":"围栏边界",
  "t-more":"更多",
  "t-visual-range": "可视范围",
  "t-belong-to": "移动",
  "t-belong-to-application": "移动应用",
  "t-belong-to-firmware": "移动固件",
  "t-global-visibility": "全局可见",
  "t-specified-range": "指定范围",
  "t-not-open-to": "不给谁看",
  "t-shared-data-already-exists": "已存在同级范围分配，如有变更，请先删除原有指定范围，再添加最新指定范围!",
  "t-partner-users-cannot-add-partner-data": "不允许选择与自己绑定的数据",
  "t-belong-to-firmware-error": "指定范围不能为空",
  "t-remember-password": "等等，我记得我的密码...",
  "t-log-in-again": "等等，我需要重新登录...",
  "t-select-device-exist-disable-device": "选择的设备中包含了被禁用的设备。",
  "t-select-device-exist-inactive-device": "选择的设备中包含了未激活的设备。",
  "t-device-sma-version-not-support": "失败,推送的设备SMA版本不支持该功能",
  "t-owner": "所有者 ",
  "t-operator": "运营商",
  "t-support-format": "支持格式",
  "t-support-resolution": "支持分辨率",
  "t-device-life-cycle-bulk-upload":"生命周期批量上传",
  "t-import-device-life-cycle-information-details":"导入生命周期信息详情",
  "t-have-joined-download-queue":"处理中",
  "t-key-value-length-is-too-long":"Key Value长度过长",
  "t-pad-mode":"填充模式标识符",
  "t-key-not-support-pad-mode-type":"不支持的填充模式标识符",
  "t-cipher-by-pubKey":"公钥加密",
  "t-not-export":"未导出",
  "t-exported":"已导出",
  "t-key-has-been-changed":"密钥已变更",
  "t-marker":"标记",
  "t-export-device-public-key":"导出公钥",
  "t-import-tid-device-tid-conflict":"设备TID与导入文件中的TID存在冲突",
  "t-please-enter-account-password":"请输入你的账号密码",
  "t-authorization-file":"授权文件",
  "t-select-device-unbind": "请选择要解除绑定的设备",
  "t-signature-name": "签名名称",
  "t-select-installed-numbers": "仅支持选择五个以内的APK文件",
  "t-success-process-message": "哦，是的，你成功处理了这条警报消息",
  "t-fail-process-message": "哦，是的，您未能处理此报警消息",
  "t-device-apk-password-length": "密码仅支持输入6位",
  "t-no-permission": "用户无权访问STORM系统，请联系管理员",
  "t-hsm-message-header": "HSM消息头",
  "t-direct-connection": "直接连接",
  "t-username-password": "用户名密码",
  "t-tls-certificate-connect": "TLS证书",
  "t-client-ks-certificate": "客户端证书(.ks)",
  "t-client-ks-password": "客户端证书密码",
  "t-ca-ts-certificate": "CA证书(.ts)",
  "t-ca-ts-password": "CA证书密码",
  "t-cert-uploaded": "已上传",
  "t-cert-not-uploaded": "未上传",
  "t-push-device-information": "注意：推送界面仅显示已激活设备，除推送激活指令仅显示未激活的设备外",
  "t-delete-push-success":"删除推送成功",
  "t-warning-to-delete-push-scheduled-tasks":"你确定要删除推送计划的任务吗？",
  "t-app-uninstall-block": "应用禁止卸载",
  "t-app-password": "应用密码",
  "t-mfa-type": "双因素认证类型",
  "t-only-add-up-to-10-items-events": "最多只能添加10个项目事件.",
  "t-search-name-sn": "Name、SN",
  "t-search-name-version": "Name、Version",
  "t-recorded-in-audit": "仅在审计日志中记录",
  "t-device-status-active-key-not-exist": "设备公钥不存在",
  "t-pos-server-version": "POS服务版本",
  "t-transaction-param-version-json-desc": "(STORM 已经根据 SN 自动集成了 TID 和 MID 到 Json 中，因此您不需要在 Json 内设置 TID 和 MID。如果您仍然设置了 TID 和 MID，我们将使用您的版本)",
  "t-select-algorithm": "请选择算法",
  "t-direct-push-success": "直接推送成功",
  "t-app-file-upload-right-spec": "文件名仅支持字母、数字、下划线以及英文句点",
  "t-range": "数据范围",
  "t-add-more-package-name-tips": "要添加多个包名，请使用逗号 (,) 将它们分隔开",
  "t-authorization-has-expired-contact-administrator": "授权已过期，请联系管理员",
  "t-confirm-modify-password": "密码过期：您的密码超过 {param} 天未修改。请重置以继续",
  "t-static-report": "静态报表",
  "t-customize-time-before-days": "自定义多少天之前",
  "t-report_export_successfully": "导出成功，请前往\"报告下载\"下载",
  "t-report-type": "报表类型",
  "t-chart-type": "图表类型",
  "t-confirm-stop": "确定要停止此项记录吗",
  "t-enter-maximum-package": "最多输入3个包名，以逗号分隔",
  "t-log-capture-stop": "抓取停止",
  "t-schedule": "日程",
  "t-data-scope": "数据范围",
  "t-report-data-range": "数据范围",
  "t-table-head": "列表头",
  "t-visual-widget": "可视化报表",
  "t-custom-report": "自定义报表",
  "t-generate-schedule": "生成日程",
  "t-authorized-list": "授权列表",
  "t-pushed": "已推送",
  "t-search-criteria": "搜索条件",
  "t-days-range": "天数范围",
  "t-maximum-json-length": "支持的最大JSON长度为32000个字符",
  "t-push-status-same-file-exist": "失败，存在相同的文件",
  "t-push-status": "推送状态",
  "t-app": "应用",
  "t-only-show-groups-with-available-devices": "仅显示存在可用设备的组",
  "t-only-show-available-devices": "仅显示可用设备",
  "t-licensed-features": "许可功能",
  "t-period": "周期",
  "t-device-is-disabled-status": "设备已禁用，请启用设备",
  "t-send-type": "发送类型",
  "t-smtp": "SMTP",
  "t-sendgrid": "SendGrid",
  "t-key-capture-device-encrypted-key-not-exist": "加密密钥不存在",
  "t-select-all-device-note": "注意：将在指定范围内所有处于活动状态且运行正常的设备上进行按键捕捉",
  "t-select-device": "选择设备",
  "t-select-group": "选择组",
  "t-all-device": "全部设备",
  "t-all-group": "全部组",
  "t-select-this-page": "本页全选",
  "t-selected-count": "已选 {count} 项",
  "t-all-devices-selected": "已选中全部 {count} 台设备",
  "t-all-groups-selected": "已选中全部 {count} 个分组",
  "t-clear-selection": "清除选择",
  "t-search-group": "搜索分组",
  "t-all-selected-cannot-unselect": "已全选，不可取消单项",
  "t-device-operation": "设备操作",
  "t-key-gen-rules-no-duplicate": "没有重复密钥",
  "t-key-gen-rules-append-existing": "在原记录上补增设备",
  "t-key-gen-rules-append-new": "新增记录补增设备",
  "t-key-gen-rules-regenerate": "重新生成",
  "t-key-gen-rules-no-duplicate-warning": "当前密钥配置不存在重复密钥",
  "t-key-gen-rules-append-existing-warning": "在原有密钥记录上补增设备关联",
  "t-key-gen-rules-append-new-warning": "创建新的密钥记录并补增设备关联",
  "t-key-gen-rules-regenerate-warning": "重新生成密钥并覆盖现有密钥记录",
  "t-proxy-settings": "下载通道配置",
  "t-download-setting": "下载设置",
  "t-proxy": "代理",
  "t-mpush": "MPUSH",
  "t-mqtt": "MQTT",
  "t-download-directly": "Amazon S3",
  "t-cdn-download": "AWS Cloud Front",
  "t-platform-download": "STORM服务平台",
  "t-feitian-proxy": "Proxy by FT",
  "t-proxy-service-by-ip": "飞天代理服务器（IP）",
  "t-proxy-service-by-domain": "飞天代理服务器（域名）",
  "t-proxy-service": "代理服务",
  "t-successful-push-tasks": "成功的推送任务",
  "t-all-push-tasks": "所有推送任务",
  "t-real-time-logs": "远程ADB调试",
  "t-issue-the-command": "命令",
  "t-communication-log": "通信日志",
  "t-refresh-interval": "刷新间隔",
  "t-local-log": "本地日志",
  "t-keywords": "关键词",
  "t-start-scraping": "开始抓取",
  "t-stop-scraping": "停止抓取",
  "t-only-supported-high-version": "“Allow downloading using mobile network” 仅对 SMA 100517 及更高版本生效",
  "t-only-supported-high-version-old-version-prompt-Upgrade": "“Automatic upgrade” 仅适用于 SMA 100517 及以上版本；低版本仅提示升级",
  "t-overwrite": "覆盖",
  "t-append": "追加",
  "t-user-login-stats": "登录日志",
  "t-search-by-user": "按用户搜索",
  "t-new-login-count": "新版登录次数",
  "t-old-login-count": "旧版登录次数",
  "t-last-login-time": "最后登录时间",
  "t-data-load-failed": "数据加载失败",
  "t-new-storm": "新 STORM",
  "t-login-type": "登录页面",
  "t-google-maps-error-tips": "地图加载失败，请检查您的网络连接或稍后再试。",
  "t-frequent-operations-try-again-later": "操作频繁，请稍候重试",
  "t-captcha-required": "请完成滑动验证",
  "t-captcha-length-error": "验证码长度应为 {param} 位",
  "t-captcha-error": "验证码错误，请重新输入",
  "t-captcha-success": "验证通过",
  "t-captcha": "验证码",
  "t-captcha-input-placeholder": "输入验证码",
  "t-captcha-expired": "验证码已过期,请重新输入",
  "t-captcha-slide-to-verify": "拖动滑块完成验证",
  "t-captcha-verify-success": "验证成功",
  "t-unlock-user": "解锁用户",
  "t-lock-user": "锁定用户",
  "t-user-locked-successfully": "用户锁定成功",
  "t-user-unlocked-successfully": "用户解锁成功",
  "t-warning-lock-user": "您确定要锁定此用户吗？",
  "t-warning-unlock-user": "您确定要解锁此用户吗？",
  "t-change-the-password-error-protect": "开启密码错误保护",
  "t-more-wrong-password-temporarily-locking": "连续输入错误密码的次数，达到该次数后账户将被临时锁定[值为5-10]",
  "t-more-wrong-password-permanently-locking": "累计输入错误密码的次数，达到该次数后账户将被永久锁定，需管理员介入解锁[值为10-30]",
  "t-temporarily-locking-automatically": "账户被临时锁定后，将在此处设定的时间后自动解锁（分钟）[值为5-60]",
  "t-dict": "系统变量配置",
  "t-dictionary": "参数",
  "t-dictionary-type": "参数类型",
  "t-enabled": "已启用",
  "t-disabled": "已禁用",
  "t-dict-data": "参数数据",
  "t-dict-label": "参数标签",
  "t-dict-value": "参数值",
  "t-rca-logs": "RCA日志",
  "t-application-not-installed": "未检测到 APP，安装后即可执行该操作，点击下方 “安装 APP” 按钮",
  "t-application-waiting-installed": "设备正在安装中，请等待...",
  "t-install-application": "安装应用程序",
  "t-reinstall-application": "重新安装应用程序",
  "t-remote-assistance": "邀请飞天远程协助",
  "t-device-needs-app-for-remote-control": "设备需要安装应用程序进行远程控制",
  "t-checking-app-installation-status": "正在检查应用程序安装状态...",
  "t-transfer-files": "传输文件",
  "t-request-sent-device-failed": "发送到设备的请求失败",
  "t-start-downloading-apps": "START DOWNLOADING APPLICATIONS TASK",
  "t-create-push-task": "创建推送任务",
  "t-from-version": "从版本",
  "t-to-version": "到版本",
  "t-delta-package": "差分包",
  "t-whole-package": "完整",
  "t-push-status-apn-sim-state-not-ready": "失败, APN SIM状态未准备好",
  "t-push-status-apn-slotindex-mistake": "失败, APN槽位索引错误",
  "t-push-status-apn-numeric-mistake": "失败, APN数值错误",
  "t-push-status-apn-mnc-mistake": "失败, APN MNC（移动网络码）错误",
  "t-push-status-apn-and-name-not-mistake": "失败, APN 名称不匹配",
  "t-push-status-apn-insert-failed": "失败, APN添加失败",
  "t-push-status-task-superseded": "失败, 已被新任务替换",
  "t-push-status-revoked-terminal-confirmed": "已撤销 (终端已确认)",
  "t-push-status-reverting": "撤销中",
  "t-push-status-init-firmware-not-supported": "失败, 初始化固件不支持",
  "t-push-status-upgrade-in-progress": "失败, 升级进行中",
  "t-push-status-already-target-version": "失败, 已是目标版本",
  "t-push-status-some-tasks-succeeded-others-failed": "失败, 部分任务成功, 其他失败",
  "t-push-status-insufficient-battery-will-execute-when-charged": "电量不足，将在充电后执行",
  "t-push-status-second-signature-enabled-device-not-bound-to-customer": "失败, 二级签名已启用, 设备未绑定客户",
  "server.mpm.device.not.in.customer": "合作伙伴已启用二级签名，设备必须绑定到客户。",
  "server.mpm.customer.without.signature.application.signed.fail": "客户未配置签名，应用签名失败。",
  "t-open-remote-control-model-notes": "请注意",
  "t-open-remote-control-model-notes-1": "该操作会产生一定流量消耗（无文件传输场景下），参考 F20 设备使用 10 分钟，预估消耗流量约 7MB。",
  "t-open-remote-control-model-notes-tha": "该操作会产生一定流量消耗。",
  "t-open-remote-control-model-notes-2": "实际流量消耗受设备性能、操作频率、画面分辨率影响。",
  "t-open-remote-control-model-waiting": "已发起远程控制请求，请稍等 ..",
  "t-sma-manager": "SMA管理器",
  "t-select-target-device": "选择目标设备",
  "t-filter-device-by-version-group": "设备可以按型号版本/组筛选，支持批量选择",
  "t-match": "匹配",
  "t-match-result": "匹配结果",
  "t-system-auto-match-version": "系统已根据设备的当前版本和目标版本 ({param}) 自动匹配了差分包",
  "t-task": "任务",
  "t-target": "目标",
  "t-task-confirmation-submit": "任务确认提交",
  "t-number-of-success-match": "成功匹配数量",
  "t-skip-number-of-unpackaged-devices": "跳过未打包设备的数量",
  "t-target-os-version": "目标系统版本",
  "t-current-os-version": "当前系统版本",
  "t-upgrade-package-type": "升级包类型",
  "t-submitting": "提交中",
  "t-file-type-not-patch-package": "上传的文件不符合差分包规则",
  "t-information": "信息",
  "t-match-diff-package": "匹配差分包",
  "t-steps": "步骤",
  "t-websocket-connected": "--- WebSocket 连接成功 ---",
  "t-start-scraping-logs": "--- 开始抓取日志 ---",
  "t-stop-scraping-logs": "--- 结束抓取日志 ---",
  "t-websocket-connection-error": "--- WebSocket 连接错误，请查看控制台 ---",
  "t-websocket-closed": "--- WebSocket 连接已关闭 ---",
  "t-logs-cleared": "--- 日志已清空 ---",
  "t-command-issued": "> 已下发命令: {command}",
  "t-command-failed": "> 命令下发失败: {command}",
  "t-command-exception": "> 命令下发异常: {message}",
  "t-websocket-not-connected": "> WebSocket 未连接，无法下发命令",
  "t-websocket-reconnecting": "> WebSocket 未连接，尝试重连...",
  "t-reconnection-success": "> 重连成功",
  "t-reconnection-attempt-failed": "> 重连尝试 {i}/5 失败",
  "t-reconnection-failed-cannot-issue": "> 重连失败，无法下发命令",
  "t-command-sent-wait": "> 命令已发送，请耐心等待结果返回...",
  "t-ft-remote-control": "FT RCA",
  "t-adb-debug-logs": "远程ADB调试日志",
  "t-differential-upgrade-strategy": "固件规则",
  "t-diff-package-rule-configuration": "固件规则配置",
  "t-version-identifier": "版本标识",
  "t-derivative-flag": "衍生标志",
  "t-diff-package-push": "差分包推送",
  "t-diff-package": "差分包",
  "t-full-package": "全量包",
  "t-scheduler-firmware-delta-package": "固件升级 - 差分包",
  "t-scheduler-firmware-full-package": "固件升级 - 整包",
  "t-upload-package-tips": "例如：需要上传从版本 {formVersion} 到版本 {toVersion} 的文件",
  "t-selected-records": "已选记录",
  "t-all-records-this-query": "本次查询全部记录",
  "t-no-corresponding-differential-package": "无对应包文件",
  "t-ota-mgmt": "OTA管理",
  "t-grayscale-publishing-strategy": "灰度发布策略",
  "t-grayscale-stage": "灰度阶段",
  "t-suggested-add": "建议添加",
  "t-model-addable": "可添加型号（单位）",
  "t-model-added": "已添加型号（单位）",
  "t-release-strategy": "发布策略",
  "t-full-release": "全量发布",
  "t-grayscale-release": "灰度发布",
  "t-auto-upgrade": "自动升级",
  "t-scheduled-upgrade": "定时升级",
  "t-remind-customer-on-upgrade": "升级提醒用户",
  "t-upgrade-task": "升级任务",
  "t-task-name": "任务名称",
  "t-target-version": "目标版本",
  "t-release-strategy-type": "发布策略类型",
  "t-upgrade-mgmt": "固件升级",
  "t-upgrade-type": "升级类型",
  "t-upgrade-option": "升级选项",
  "t-current-version": "当前版本",
  "t-update-log": "更新日志",
  "t-last-request-time": "最后请求时间",
  "t-cancel-upgrade": "取消升级",
  "t-task-cannot-be-revoked": "任务无法取消",
  "t-device-list": "设备列表",
  "t-distribution-map": "固件概览",
  "t-whole-package-push": "全量包推送",
  "t-full-upgrade": "全量升级",
  "t-delta-upgrade": "增量升级",
  "t-not-equipped-upgrades": "排除已有升级任务设备",
  "t-source-to-target": "源到目标",
  "t-confirm-change": "确认切换",
  "t-confirm-change-proxy": "确认切换代理配置？",
  "t-warning": "警告",
  "t-change-model-warning": "代理配置变更警告",
  "t-app-used-quota": "应用已用配额",
  "t-firmware-used-quota": "固件已用配额",
  "t-switch-to": "切换至",
  "t-app-available-use": "应用可用配额",
  "t-firmware-available-use": "固件可用配额",
  "t-forced-switch":"强制切换",
  "t-start-time-cannot-be-greater-than-end-time": "开始时间不能晚于结束时间",
  "t-allow-download-during-sleep": "允许睡眠期间下载",
  "t-allow-download-during-sleep-desc": "选择此选项,终端将允许在睡眠模式下下载固件文件",
  "t-not-upgrade-task-by-firmware-tips": "无操作系统升级任务",
  "t-not-upgrade-task-by-firmware-tips-desc": "排除已有OS升级任务的设备",
  "t-filters-device-by-status-title": "默认排除的设备",
  "t-filters-device-by-status-desc1": "- OS已经是目标版本",
  "t-filters-device-by-status-desc2": "- 未激活",
  "t-filters-device-by-status-desc3": "- 在地理围栏外",
  "t-filters-device-by-status-desc4": "- 在国家之外",
  "t-succeeded": "成功",
  "t-failed": "失败",
  "t-revoked": "已撤销",
  "t-auto-recognize-version": "自动识别版本",
  "t-revoked-task-tips": "只有已创建但尚未由终端启动的任务可以被撤销（SMA版本必须为200112或更高）",
  "t-pos-firmware-upgrading-to-countdown": "POS端固件升级时，显示倒计时30秒",
  "t-product": "产品",
  "t-ota-error-logs": "设备异常事件",
  "t-event-type": "事件类型",
  "t-active-os-upgrade-tasks": "正在执行固件升级任务(最近12个月)",
  "t-file-upload-error-try-again": "上传的固件格式不正确，请重试",
  "t-update-time": "更新时间",
  "t-filter-same-versions": "排除目标版本设备",
  "t-filter-same-versions-desc": "勾选此项后，将排除已是目标版本的设备。",
  "t-allow-same-version-upgrade": "允许同版本升级",
  "t-allow-same-version-upgrade-desc": "选择此选项，终端将允许升级到与当前版本相同的固件版本",
  "t-replace-uncompleted-tasks": "覆盖任务",
  "t-replace-uncompleted-tasks-desc": "新任务将替换设备中未完成的旧任务。",
  "t-time-period-not-allowed-across-days": "时间段不允许跨天",
  "t-file-upload-successful": `设备{device}对应的{type}上传成功！`,
  "t-select-identical-rule": "您选择了重复的规则",
  "t-formversion-toversion-same": "起始版本和目标版本不能相同",
  "t-please-complete-the-information-for-all-rules": "请填写完整的规则信息",
  "t-all-day": "全天",
  "t-custom-period": "自定义时间段",
  "t-json-err-check-retry": "JSON格式错误，请检查输入内容",
  "t-only-supported-high-version-new": "SMA 100517 及以上版本支支持",
  "t-search_report_name_user": "报表名称、创建人",
  "t-password-must-be-6-digits": "请输入6位数字密码",
  "t-batch-operation": "批量操作",
  "t-sub-action": "子操作",
  "t-batch-application-fail-cause": "应用程序失败原因",
  "t-reissue-device-warning": "在已存在的记录中增加设备",
  "t-overwrite-device-key-warning": "存在相同密钥",
  "t-display-only-devices-without-generated-keys": "仅显示未生成密钥的设备",
  "t-historical-records-have-been-detected": "检测到已存在{count}条历史记录。如果已选设备已生成该密钥，旧记录将被删除。",
  "t-firmware-sma-version-warning": "注意：当 SMA 版本低于 200117 时，设备不支持此配置项。在创建终端配置任务时，系统将自动排除固件相关内容。",
  "t-exclude-devices-with-terminal-profile-tasks": "排除已有终端初始化任务的设备",
  "t-encrypt-type": "加密类型",
  "t-auto-select-recommended": "AUTO - 自动选择（推荐）",
  "t-force-ecc": "ECC",
  "t-force-rsa": "RSA",
  "t-tr34": "TR34",
  "t-encrypt-type-hint-auto": "AUTO: 优先使用ECC加密，设备不支持时自动回退到RSA",
  "t-encrypt-type-hint-ecc": "ECC: 仅使用ECC加密，设备不支持时注入失败",
  "t-encrypt-type-hint-rsa": "RSA: 仅使用RSA加密",
  "t-encrypt-type-hint-tr34": "TR34: 使用TR34标准格式进行密钥注入",
  "t-tr34-auth-required": "选择TR34格式前，请先完成双向认证",
  "t-go-to-mutual-auth": "前往绑定密钥元数据",
  "t-device-ecc-not-supported": "设备不支持ECC加密",
  "t-key-capture-device-cert-not-exist": "设备证书不存在",
  "t-key-capture-device-not-authenticated": "设备未认证",
  "t-key-capture-device-mutual-auth-unbound-key-invalidated": "设备双向认证未绑定，密钥已失效",
  "t-key-capture-key-derivation-failed": "密钥分散失败",
  "t-root-ca-certificate": "Root CA 证书",
  "t-sub-ca-certificate": "Sub CA 证书",
  "t-server-certificate": "Server 证书",
  "t-import-certificate": "导入证书",
  "t-export-csr": "导出 CSR",
  "t-generate-csr": "生成 CSR",
  "t-key-size": "密钥长度",
  "t-valid": "有效",
  "t-expired": "已过期",
  "t-public-key-algorithm": "公钥算法",
  "t-private-key-location": "私钥位置",
  "t-re-import": "重新导入",
  "t-rki-root-ca-alert": "Root CA 证书由飞天工厂签发，平台仅存储用于验证证书链，不可修改。",
  "t-rki-sub-ca-alert": "Sub CA 证书由飞天工厂签发后导入平台，用于双向认证时验证 Device Cert 证书链。",
  "t-rki-server-cert-alert": "Server Cert 由平台在 HSM 中生成密钥对，导出 CSR 给飞天工厂签发。私钥永不出 HSM。",
  "server.cert.root.ca.not.found": "未找到 Root CA，无法验证 Sub CA",
  "server.cert.verify.sub.ca.failed": "证书验证失败",
  "server.cert.import.failed": "Server Certificate 导入失败",
  "server.cert.private.key.not.found": "未找到对应的私钥，请先生成 CSR",
  "server.cert.private.key.mismatch": "私钥与 Server Certificate 不匹配",
  "server.cert.expired": "证书已过期，请重新签发有效的证书",
  "server.cert.not.yet.valid": "证书尚未生效，请检查签发时间",
  "server.cert.not.exists": "服务器证书不存在",
  "t-mutual-auth": "绑定密钥安全属性",
  "t-initiate-auth": "绑定密钥安全属性",
  "t-batch-auth": "批量认证",
  "t-rki-mutual-auth-alert": "双向认证流程：TMS 下发认证指令 → 设备上报 Device Cert → TMS 用 Sub CA 验证 → TMS 下发 Server Cert → 设备用 Sub CA 验证 → 认证成功",
  "t-auth-status": "状态",
  "t-auth-time": "绑定时间",
  "t-authenticated": "绑定成功",
  "t-unauthenticated": "未认证",
  "t-authenticating": "绑定中",
  "t-auth-failed": "绑定失败",
  "t-auth-fail-cause": "失败原因",
  "t-unbound": "待生成CSR",
  "t-server-cert-not-exist": "对应合作伙伴的服务端证书不存在，请先配置服务端证书后再发起绑定",
  "t-csr-pending": "等待CSR上报",
  "t-csr-received": "CSR已上报",
  "t-not-authenticated": "待绑定",
  "t-cert-pending-inject": "证书待注入",
  "t-inject-cert": "注入证书",
  "t-sync-device-cert": "同步设备证书",
  "t-sync-device-random-number": "同步设备随机数",
  "t-download-csr": "下载CSR",
  "t-download-success": "下载成功",
  "t-csr-content-empty": "CSR内容为空",
  "t-upload-cert": "上传证书",
  "t-cert-file": "证书文件",
  "t-upload-success": "上传成功",
  "t-server-exception-try-later": "服务器异常，请稍后再试！",
  "t-gray-release-template": "灰度发布模板",
  "t-template-name": "模板名称",
  "t-strategy-type": "策略类型",
  "t-release-mode": "发布模式",
  "t-batch-config": "阶段配置",
  "t-auto-promote-threshold": "自动晋级阈值",
  "t-auto-promote-threshold-required": "自动晋级阈值不能为空",
  "t-auto-promote-threshold-range": "自动晋级阈值必须大于0且不能超过100",
  "t-fast-release": "快速发布",
  "t-standard-release": "标准发布",
  "t-conservative-release": "保守发布",
  "t-by-percentage": "按百分比",
  "t-by-device-count": "按设备数量",
  "t-template-name-required": "模板名称不能为空",
  "t-batch-config-required": "批次配置不能为空",
  "t-enabled-success": "启用成功",
  "t-disabled-success": "禁用成功",
  "t-enabled-cannot-delete": "启用状态不允许删除",
  "t-operation-failed": "操作失败",
  "t-add-batch": "添加阶段",
  "t-threshold-hint": "固件升级成功率≥该阈值时自动晋级下一批次",
  "t-collect-duration": "健康数据采集时长",
  "t-collect-count": "健康数据采集次数",
  "t-collect-duration-required": "健康数据采集时长不能为空",
  "t-collect-count-required": "健康数据采集次数不能为空",
  "t-times": "次",
  "t-units": "台",
  "t-percentage": "百分比",
  "t-device-count": "设备数量",
  "t-custom": "自定义",
  "t-must-be-greater": "必须大于前面的值",
  "t-use-gray-release-template": "灰度升级",
  "t-select-template": "选择模板",
  "t-gray-release-allocation-valid": "已选择 {count} 台设备，满足 {stages} 个升级阶段的分配要求。",
  "t-gray-release-allocation-insufficient": "当前选择 {count} 台设备，所选设备数需大于模板各阶段设备数量之和（{required} 台），还差 {missing} 台。",
  "t-gray-release-allocation-invalid-template": "当前灰度模板无法为每个升级阶段至少分配一台设备。",
  "t-gray-release-task-detail": "灰度发布任务详情",
  "t-gray-task": "灰度任务",
  "t-gray-detail": "查看灰度详情",
  "t-gray-template-name": "灰度模板名称",
  "t-current-batch": "当前批次",
  "t-total-progress": "总进度",
  "t-health-rate": "健康度",
  "t-task-status": "任务状态",
  "t-pause": "暂停",
  "t-resume": "恢复",
  "t-force-promote": "强制晋级",
  "t-enter-next-stage": "跳入下一阶段",
  "t-cancel-task": "取消任务",
  "t-batch-progress": "批次进度",
  "t-progress": "进度",
  "t-success-rate": "成功率",
  "t-threshold": "阈值",
  "t-no-batch-data": "暂无批次数据",
  "t-health-evaluation": "设备升级情况概览",
  "t-pass": "达标",
  "t-no-health-data": "暂无健康度数据",
  "t-paused-success": "任务暂停成功",
  "t-resume-success": "任务恢复成功",
  "t-force-promote-success": "已强制晋级",
  "t-enter-next-stage-success": "已跳入下一阶段",
  "t-stage": "阶段",
  "t-upgrade-stage-progress-overview": "升级阶段进度概览",
  "t-cancel-success": "任务已取消",
  "t-not-started": "未开始",
  "t-in-progress": "执行中",
  "t-paused": "已暂停",
  "t-completed": "已完成",
  "t-cancelled": "已取消",
  "t-terminated": "已终止",
  "t-auto-promote": "自动晋级",
  "t-health-evaluated-success": "健康度评估已完成",
  "t-health-all-passed": "全部健康检查通过",
  "t-health-not-passed": "健康检查未通过",
  "t-health-all-passed-desc": "所有核心指标均达到阈值",
  "t-health-not-passed-desc": "部分核心指标未达到阈值",
  "t-card-read-success-rate": "读卡成功率",
  "t-print-status": "打印状态",
  "t-core-health": "核心健康指标",
  "t-firmware-upgrade-success-rate": "固件升级成功率",
  "t-app-name": "应用名称",
  "t-file-path": "文件路径",
  "t-app-type": "应用类型",
  "t-ftrca-desc": "远程控制代理",
  "t-fttha-desc": "终端健康代理",
  "t-apk-parse-result": "APK 解析结果",
  "t-file-not-found": "文件未找到",
  "t-max-count": "最大数量",
  "t-last-batch-must-be-unlimited": "最后一批必须为不限制",
  "t-must-set-device-count": "必须设置设备数量，不能为不限制",
  "server.partner.traffic.quota.config.already.exists": "该合作伙伴配额配置已存在"
}
